interface IStateOption {
  key: string;
  label: string;
}

export interface IAddressFormat {
  city_label: string;
  fields: string[];
  postcode_hint?: string;
  postcode_label?: string;
  postcode_pattern?: RegExp | string;
  required: string[];
  state_label?: string;
  state_options?: IStateOption[];
}

export interface IAddressFormats {
  [key: string]: IAddressFormat;
}

export const AddressFormats: IAddressFormats = {
  AD: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'AD700',
    postcode_label: 'Postal code',
    postcode_pattern: 'AD[1-7]0\\d',
    required: [],
    state_options: [
      {
        key: '07',
        label: 'Andorra la Vella',
      },
      {
        key: '02',
        label: 'Canillo',
      },
      {
        key: '03',
        label: 'Encamp',
      },
      {
        key: '08',
        label: 'Escaldes-Engordany',
      },
      {
        key: '04',
        label: 'La Massana',
      },
      {
        key: '05',
        label: 'Ordino',
      },
      {
        key: '06',
        label: 'Sant Julià de Lòria',
      },
    ],
  },
  AE: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: ['State'],
    state_label: 'Emirate',
    state_options: [
      {
        key: 'AZ',
        label: 'Abu Dhabi',
      },
      {
        key: 'AJ',
        label: 'Ajman',
      },
      {
        key: 'DU',
        label: 'Dubai',
      },
      {
        key: 'FU',
        label: 'Fujairah',
      },
      {
        key: 'RK',
        label: 'Ras al Khaimah',
      },
      {
        key: 'SH',
        label: 'Sharjah',
      },
      {
        key: 'UQ',
        label: 'Umm Al Quwain',
      },
    ],
  },
  AF: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '3801',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  AG: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  AI: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '2640',
    postcode_label: 'Postal code',
    postcode_pattern: '(?:AI-)?2640',
    required: [],
  },
  AL: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '3501',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  AM: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '0010',
    postcode_label: 'Postal code',
    postcode_pattern: '(?:37)?\\d{4}',
    required: [],
    state_label: 'Province',
    state_options: [
      {
        key: 'AG',
        label: 'Aragatsotn',
      },
      {
        key: 'AR',
        label: 'Ararat',
      },
      {
        key: 'AV',
        label: 'Armavir',
      },
      {
        key: 'GR',
        label: 'Gegharkunik',
      },
      {
        key: 'KT',
        label: 'Kotayk',
      },
      {
        key: 'LO',
        label: 'Lori',
      },
      {
        key: 'SH',
        label: 'Shirak',
      },
      {
        key: 'SU',
        label: 'Syunik',
      },
      {
        key: 'TV',
        label: 'Tavush',
      },
      {
        key: 'VD',
        label: 'Vayots Dzor',
      },
      {
        key: 'ER',
        label: 'Yerevan',
      },
    ],
  },
  AN: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  AO: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  AQ: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  AR: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: 'X5187XAB',
    postcode_label: 'Postal code',
    postcode_pattern: '((?:[A-HJ-NP-Z])?\\d{4})([A-Z]{3})?',
    required: [],
    state_label: 'Province',
    state_options: [
      {
        key: 'B',
        label: 'Buenos Aires',
      },
      {
        key: 'K',
        label: 'Catamarca',
      },
      {
        key: 'H',
        label: 'Chaco',
      },
      {
        key: 'U',
        label: 'Chubut',
      },
      {
        key: 'C',
        label: 'Ciudad Autónoma de Buenos Aires',
      },
      {
        key: 'W',
        label: 'Corrientes',
      },
      {
        key: 'X',
        label: 'Córdoba',
      },
      {
        key: 'E',
        label: 'Entre Ríos',
      },
      {
        key: 'P',
        label: 'Formosa',
      },
      {
        key: 'Y',
        label: 'Jujuy',
      },
      {
        key: 'L',
        label: 'La Pampa',
      },
      {
        key: 'F',
        label: 'La Rioja',
      },
      {
        key: 'M',
        label: 'Mendoza',
      },
      {
        key: 'N',
        label: 'Misiones',
      },
      {
        key: 'Q',
        label: 'Neuquén',
      },
      {
        key: 'R',
        label: 'Río Negro',
      },
      {
        key: 'A',
        label: 'Salta',
      },
      {
        key: 'J',
        label: 'San Juan',
      },
      {
        key: 'D',
        label: 'San Luis',
      },
      {
        key: 'Z',
        label: 'Santa Cruz',
      },
      {
        key: 'S',
        label: 'Santa Fe',
      },
      {
        key: 'G',
        label: 'Santiago del Estero',
      },
      {
        key: 'V',
        label: 'Tierra del Fuego',
      },
      {
        key: 'T',
        label: 'Tucumán',
      },
    ],
  },
  AS: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '96799',
    postcode_label: 'Zip code',
    postcode_pattern: '(96799)(?:[ \\-](\\d{4}))?',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
  },
  AT: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '3741',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'Postcode'],
  },
  AU: {
    city_label: 'City/Suburb',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '3001',
    postcode_label: 'Post code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
    state_options: [
      {
        key: 'ACT',
        label: 'Australian Capital Territory',
      },
      {
        key: 'NSW',
        label: 'New South Wales',
      },
      {
        key: 'NT',
        label: 'Northern Territory',
      },
      {
        key: 'QLD',
        label: 'Queensland',
      },
      {
        key: 'SA',
        label: 'South Australia',
      },
      {
        key: 'TAS',
        label: 'Tasmania',
      },
      {
        key: 'VIC',
        label: 'Victoria',
      },
      {
        key: 'WA',
        label: 'Western Australia',
      },
    ],
  },
  AW: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  AX: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '22430',
    postcode_label: 'Postal code',
    postcode_pattern: '22\\d{3}',
    required: ['City', 'Postcode'],
  },
  AZ: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  BA: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '71000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  BB: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: 'BB22025',
    postcode_label: 'Postal code',
    postcode_pattern: 'BB\\d{5}',
    required: [],
    state_label: 'Parish',
  },
  BD: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1340',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  BE: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '4000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'Postcode'],
  },
  BF: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  BG: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1700',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  BH: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '317',
    postcode_label: 'Postal code',
    postcode_pattern: '(?:\\d|1[0-2])\\d{2}',
    required: [],
  },
  BI: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  BJ: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  BL: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '97100',
    postcode_label: 'Postal code',
    postcode_pattern: '9[78][01]\\d{2}',
    required: ['City', 'Postcode'],
  },
  BM: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'HM 12',
    postcode_label: 'Postal code',
    postcode_pattern: '[A-Z]{2} ?[A-Z0-9]{2}',
    required: [],
  },
  BN: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'BA1511',
    postcode_label: 'Postal code',
    postcode_pattern: '[A-Z]{2} ?\\d{4}',
    required: [],
  },
  BO: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  BQ: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  BR: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '40301-110',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}-?\\d{3}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
    state_options: [
      {
        key: 'AC',
        label: 'Acre',
      },
      {
        key: 'AL',
        label: 'Alagoas',
      },
      {
        key: 'AP',
        label: 'Amapá',
      },
      {
        key: 'AM',
        label: 'Amazonas',
      },
      {
        key: 'BA',
        label: 'Bahia',
      },
      {
        key: 'CE',
        label: 'Ceará',
      },
      {
        key: 'DF',
        label: 'Distrito Federal',
      },
      {
        key: 'ES',
        label: 'Espírito Santo',
      },
      {
        key: 'GO',
        label: 'Goiás',
      },
      {
        key: 'MA',
        label: 'Maranhão',
      },
      {
        key: 'MT',
        label: 'Mato Grosso',
      },
      {
        key: 'MS',
        label: 'Mato Grosso do Sul',
      },
      {
        key: 'MG',
        label: 'Minas Gerais',
      },
      {
        key: 'PR',
        label: 'Paraná',
      },
      {
        key: 'PB',
        label: 'Paraíba',
      },
      {
        key: 'PA',
        label: 'Pará',
      },
      {
        key: 'PE',
        label: 'Pernambuco',
      },
      {
        key: 'PI',
        label: 'Piauí',
      },
      {
        key: 'RN',
        label: 'Rio Grande do Norte',
      },
      {
        key: 'RS',
        label: 'Rio Grande do Sul',
      },
      {
        key: 'RJ',
        label: 'Rio de Janeiro',
      },
      {
        key: 'RO',
        label: 'Rondônia',
      },
      {
        key: 'RR',
        label: 'Roraima',
      },
      {
        key: 'SC',
        label: 'Santa Catarina',
      },
      {
        key: 'SE',
        label: 'Sergipe',
      },
      {
        key: 'SP',
        label: 'São Paulo',
      },
      {
        key: 'TO',
        label: 'Tocantins',
      },
    ],
  },
  BS: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: [],
    state_label: 'Island',
    state_options: [
      {
        key: 'Abaco Islands',
        label: 'Abaco Islands',
      },
      {
        key: 'AK',
        label: 'Acklins',
      },
      {
        key: 'Andros Island',
        label: 'Andros Island',
      },
      {
        key: 'BY',
        label: 'Berry Islands',
      },
      {
        key: 'BI',
        label: 'Bimini',
      },
      {
        key: 'CI',
        label: 'Cat Island',
      },
      {
        key: 'Crooked Island',
        label: 'Crooked Island',
      },
      {
        key: 'Eleuthera',
        label: 'Eleuthera',
      },
      {
        key: 'EX',
        label: 'Exuma and Cays',
      },
      {
        key: 'Grand Bahama',
        label: 'Grand Bahama',
      },
      {
        key: 'HI',
        label: 'Harbour Island',
      },
      {
        key: 'IN',
        label: 'Inagua',
      },
      {
        key: 'LI',
        label: 'Long Island',
      },
      {
        key: 'MG',
        label: 'Mayaguana',
      },
      {
        key: 'New Providence',
        label: 'New Providence',
      },
      {
        key: 'RI',
        label: 'Ragged Island',
      },
      {
        key: 'RC',
        label: 'Rum Cay',
      },
      {
        key: 'SS',
        label: 'San Salvador',
      },
      {
        key: 'SW',
        label: 'Spanish Wells',
      },
    ],
  },
  BT: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '35003',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  BV: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  BW: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  BY: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '220050',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
    state_label: 'Province',
  },
  BZ: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  CA: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: 'K1A 0B1',
    postcode_label: 'Postal code',
    postcode_pattern:
      '[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d',
    required: ['City', 'State', 'Postcode'],
    state_label: 'Province',
    state_options: [
      {
        key: 'AB',
        label: 'Alberta',
      },
      {
        key: 'BC',
        label: 'British Columbia',
      },
      {
        key: 'MB',
        label: 'Manitoba',
      },
      {
        key: 'NB',
        label: 'New Brunswick',
      },
      {
        key: 'NL',
        label: 'Newfoundland and Labrador',
      },
      {
        key: 'NT',
        label: 'Northwest Territories',
      },
      {
        key: 'NS',
        label: 'Nova Scotia',
      },
      {
        key: 'NU',
        label: 'Nunavut',
      },
      {
        key: 'ON',
        label: 'Ontario',
      },
      {
        key: 'PE',
        label: 'Prince Edward Island',
      },
      {
        key: 'QC',
        label: 'Quebec',
      },
      {
        key: 'SK',
        label: 'Saskatchewan',
      },
      {
        key: 'YT',
        label: 'Yukon',
      },
    ],
  },
  CC: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '6799',
    postcode_label: 'Postal code',
    postcode_pattern: '6799',
    required: [],
    state_label: 'Province',
  },
  CD: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  CF: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  CG: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  CH: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'CH-3030',
    postcode_label: 'Postal code',
    postcode_pattern: 'CH-\\d{4}',
    required: ['City', 'Postcode'],
  },
  CI: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  CK: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  CL: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '8329100',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{7}',
    required: [],
    state_label: 'Province',
    state_options: [
      {
        key: 'AN',
        label: 'Antofagasta',
      },
      {
        key: 'AR',
        label: 'Araucanía',
      },
      {
        key: 'AP',
        label: 'Arica y Parinacota',
      },
      {
        key: 'AT',
        label: 'Atacama',
      },
      {
        key: 'AI',
        label: 'Aysén del General Carlos Ibáñez del Campo',
      },
      {
        key: 'BI',
        label: 'Biobío',
      },
      {
        key: 'CO',
        label: 'Coquimbo',
      },
      {
        key: 'LI',
        label: "Libertador General Bernardo O'Higgins",
      },
      {
        key: 'LL',
        label: 'Los Lagos',
      },
      {
        key: 'LR',
        label: 'Los Ríos',
      },
      {
        key: 'MA',
        label: 'Magallanes y de la Antártica Chilena',
      },
      {
        key: 'ML',
        label: 'Maule',
      },
      {
        key: 'RM',
        label: 'Metropolitana de Santiago',
      },
      {
        key: 'TA',
        label: 'Tarapacá',
      },
      {
        key: 'VS',
        label: 'Valparaíso',
      },
    ],
  },
  CM: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  CN: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '100808',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'Province',
    state_options: [
      {
        key: '34',
        label: 'Anhui Sheng',
      },
      {
        key: '11',
        label: 'Beijing Shi',
      },
      {
        key: '50',
        label: 'Chongqing Shi',
      },
      {
        key: '35',
        label: 'Fujian Sheng',
      },
      {
        key: '62',
        label: 'Gansu Sheng',
      },
      {
        key: '44',
        label: 'Guangdong Sheng',
      },
      {
        key: '45',
        label: 'Guangxi Zhuangzuzizhiqu',
      },
      {
        key: '52',
        label: 'Guizhou Sheng',
      },
      {
        key: '46',
        label: 'Hainan Sheng',
      },
      {
        key: '13',
        label: 'Hebei Sheng',
      },
      {
        key: '23',
        label: 'Heilongjiang Sheng',
      },
      {
        key: '41',
        label: 'Henan Sheng',
      },
      {
        key: '91',
        label: 'Hong Kong',
      },
      {
        key: '42',
        label: 'Hubei Sheng',
      },
      {
        key: '43',
        label: 'Hunan Sheng',
      },
      {
        key: '32',
        label: 'Jiangsu Sheng',
      },
      {
        key: '36',
        label: 'Jiangxi Sheng',
      },
      {
        key: '22',
        label: 'Jilin Sheng',
      },
      {
        key: '21',
        label: 'Liaoning Sheng',
      },
      {
        key: '92',
        label: 'Macau',
      },
      {
        key: '15',
        label: 'Neimenggu Zizhiqu',
      },
      {
        key: '64',
        label: 'Ningxia Huizuzizhiqu',
      },
      {
        key: '63',
        label: 'Qinghai Sheng',
      },
      {
        key: '61',
        label: 'Shaanxi Sheng',
      },
      {
        key: '37',
        label: 'Shandong Sheng',
      },
      {
        key: '31',
        label: 'Shanghai Shi',
      },
      {
        key: '14',
        label: 'Shanxi Sheng',
      },
      {
        key: '51',
        label: 'Sichuan Sheng',
      },
      {
        key: '71',
        label: 'Taiwan',
      },
      {
        key: '12',
        label: 'Tianjin Shi',
      },
      {
        key: '65',
        label: 'Xinjiang Weiwuerzizhiqu',
      },
      {
        key: '54',
        label: 'Xizang Zizhiqu',
      },
      {
        key: '53',
        label: 'Yunnan Sheng',
      },
      {
        key: '33',
        label: 'Zhejiang Sheng',
      },
    ],
  },
  CO: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '760011',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: ['State'],
    state_label: 'Department',
  },
  CR: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '2010',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4,5}|\\d{3}-\\d{4}',
    required: ['City', 'State'],
    state_label: 'Province',
  },
  CU: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  CV: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '7600',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
    state_label: 'Island',
    state_options: [
      {
        key: 'BV',
        label: 'Boa Vista',
      },
      {
        key: 'BR',
        label: 'Brava',
      },
      {
        key: 'Fogo',
        label: 'Fogo',
      },
      {
        key: 'MA',
        label: 'Maio',
      },
      {
        key: 'SL',
        label: 'Sal',
      },
      {
        key: 'Santiago',
        label: 'Santiago',
      },
      {
        key: 'Santo Antão',
        label: 'Santo Antão',
      },
      {
        key: 'São Nicolau',
        label: 'São Nicolau',
      },
      {
        key: 'SV',
        label: 'São Vicente',
      },
    ],
  },
  CW: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  CX: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '6798',
    postcode_label: 'Postal code',
    postcode_pattern: '6798',
    required: [],
    state_label: 'Province',
  },
  CY: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1900',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  CZ: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '225 99',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3} ?\\d{2}',
    required: [],
  },
  DE: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '53225',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'Postcode'],
  },
  DJ: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  DK: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1566',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'Postcode'],
  },
  DM: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  DO: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '11903',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  DZ: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '16027',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  EC: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '092301',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
  },
  EE: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '11212',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  EG: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '11599',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
    state_label: 'Province',
    state_options: [
      {
        key: 'ALX',
        label: 'Alexandria Governorate',
      },
      {
        key: 'SHR',
        label: 'Ash Sharqia Governorate',
      },
      {
        key: 'ASN',
        label: 'Aswan Governorate',
      },
      {
        key: 'AST',
        label: 'Asyut Governorate',
      },
      {
        key: 'BNS',
        label: 'Beni Suef Governorate',
      },
      {
        key: 'C',
        label: 'Cairo Governorate',
      },
      {
        key: 'DK',
        label: 'Dakahlia Governorate',
      },
      {
        key: 'DT',
        label: 'Damietta Governorate',
      },
      {
        key: 'BH',
        label: 'El Beheira Governorate',
      },
      {
        key: 'FYM',
        label: 'Faiyum Governorate',
      },
      {
        key: 'GH',
        label: 'Gharbia Governorate',
      },
      {
        key: 'GZ',
        label: 'Giza Governorate',
      },
      {
        key: 'IS',
        label: 'Ismailia Governorate',
      },
      {
        key: 'KFS',
        label: 'Kafr El Sheikh Governorate',
      },
      {
        key: 'LX',
        label: 'Luxor Governorate',
      },
      {
        key: 'MT',
        label: 'Matrouh Governorate',
      },
      {
        key: 'MN',
        label: 'Menia Governorate',
      },
      {
        key: 'MNF',
        label: 'Menofia Governorate',
      },
      {
        key: 'WAD',
        label: 'New Valley Governorate',
      },
      {
        key: 'SIN',
        label: 'North Sinai Governorate',
      },
      {
        key: 'PTS',
        label: 'Port Said Governorate',
      },
      {
        key: 'KB',
        label: 'Qalyubia Governorate',
      },
      {
        key: 'KN',
        label: 'Qena Governorate',
      },
      {
        key: 'BA',
        label: 'Red Sea Governorate',
      },
      {
        key: 'SHG',
        label: 'Sohag Governorate',
      },
      {
        key: 'JS',
        label: 'South Sinai Governorate',
      },
      {
        key: 'SUZ',
        label: 'Suez Governorate',
      },
    ],
  },
  EH: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '72000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  ER: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  ES: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '28070',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'Province',
    state_options: [
      {
        key: 'C',
        label: 'A Coruña',
      },
      {
        key: 'AB',
        label: 'Albacete',
      },
      {
        key: 'A',
        label: 'Alicante',
      },
      {
        key: 'AL',
        label: 'Almería',
      },
      {
        key: 'O',
        label: 'Asturias',
      },
      {
        key: 'BA',
        label: 'Badajoz',
      },
      {
        key: 'B',
        label: 'Barcelona',
      },
      {
        key: 'BU',
        label: 'Burgos',
      },
      {
        key: 'S',
        label: 'Cantabria',
      },
      {
        key: 'CS',
        label: 'Castellón',
      },
      {
        key: 'CE',
        label: 'Ceuta',
      },
      {
        key: 'CR',
        label: 'Ciudad Real',
      },
      {
        key: 'CU',
        label: 'Cuenca',
      },
      {
        key: 'CC',
        label: 'Cáceres',
      },
      {
        key: 'CA',
        label: 'Cádiz',
      },
      {
        key: 'CO',
        label: 'Córdoba',
      },
      {
        key: 'GI',
        label: 'Girona',
      },
      {
        key: 'GR',
        label: 'Granada',
      },
      {
        key: 'GU',
        label: 'Guadalajara',
      },
      {
        key: 'SS',
        label: 'Guipúzcoa',
      },
      {
        key: 'H',
        label: 'Huelva',
      },
      {
        key: 'HU',
        label: 'Huesca',
      },
      {
        key: 'PM',
        label: 'Islas Baleares',
      },
      {
        key: 'J',
        label: 'Jaén',
      },
      {
        key: 'LO',
        label: 'La Rioja',
      },
      {
        key: 'GC',
        label: 'Las Palmas',
      },
      {
        key: 'LE',
        label: 'León',
      },
      {
        key: 'L',
        label: 'Lleida',
      },
      {
        key: 'LU',
        label: 'Lugo',
      },
      {
        key: 'M',
        label: 'Madrid',
      },
      {
        key: 'ML',
        label: 'Melilla',
      },
      {
        key: 'MU',
        label: 'Murcia',
      },
      {
        key: 'MA',
        label: 'Málaga',
      },
      {
        key: 'NA',
        label: 'Navarra',
      },
      {
        key: 'OR',
        label: 'Ourense',
      },
      {
        key: 'P',
        label: 'Palencia',
      },
      {
        key: 'PO',
        label: 'Pontevedra',
      },
      {
        key: 'SA',
        label: 'Salamanca',
      },
      {
        key: 'TF',
        label: 'Santa Cruz de Tenerife',
      },
      {
        key: 'SG',
        label: 'Segovia',
      },
      {
        key: 'SE',
        label: 'Sevilla',
      },
      {
        key: 'SO',
        label: 'Soria',
      },
      {
        key: 'T',
        label: 'Tarragona',
      },
      {
        key: 'TE',
        label: 'Teruel',
      },
      {
        key: 'TO',
        label: 'Toledo',
      },
      {
        key: 'V',
        label: 'Valencia',
      },
      {
        key: 'VA',
        label: 'Valladolid',
      },
      {
        key: 'BI',
        label: 'Vizcaya',
      },
      {
        key: 'ZA',
        label: 'Zamora',
      },
      {
        key: 'Z',
        label: 'Zaragoza',
      },
      {
        key: 'VI',
        label: 'Álava',
      },
      {
        key: 'AV',
        label: 'Ávila',
      },
    ],
  },
  ET: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  FI: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '00011',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'Postcode'],
  },
  FJ: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  FK: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'FIQQ 1ZZ',
    postcode_label: 'Postal code',
    postcode_pattern: 'FIQQ 1ZZ',
    required: ['City', 'Postcode'],
  },
  FM: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '96944',
    postcode_label: 'Zip code',
    postcode_pattern: '(9694[1-4])(?:[ \\-](\\d{4}))?',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
  },
  FO: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '100',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3}',
    required: [],
  },
  FR: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '33506',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{2} ?\\d{3}',
    required: ['City', 'Postcode'],
  },
  GA: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  GB: {
    city_label: 'Town/City',
    fields: ['City', 'Postcode', 'State'],
    postcode_hint: 'BFPO 61',
    postcode_label: 'Postal code',
    postcode_pattern:
      'GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\\d{1,4}',
    required: ['City', 'Postcode'],
    state_label: 'County',
  },
  GD: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  GE: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '0101',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  GF: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '97300',
    postcode_label: 'Postal code',
    postcode_pattern: '9[78]3\\d{2}',
    required: ['City', 'Postcode'],
  },
  GG: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'GY2 2BT',
    postcode_label: 'Postal code',
    postcode_pattern: 'GY\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}',
    required: ['City', 'Postcode'],
  },
  GH: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  GI: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'GX11 1AA',
    postcode_label: 'Postal code',
    postcode_pattern: 'GX11 1AA',
    required: [],
  },
  GL: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '3911',
    postcode_label: 'Postal code',
    postcode_pattern: '39\\d{2}',
    required: ['City', 'Postcode'],
  },
  GM: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  GN: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '100',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3}',
    required: [],
  },
  GP: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '97100',
    postcode_label: 'Postal code',
    postcode_pattern: '9[78][01]\\d{2}',
    required: ['City', 'Postcode'],
  },
  GQ: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  GR: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '101 88',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3} ?\\d{2}',
    required: ['City', 'Postcode'],
  },
  GS: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'SIQQ 1ZZ',
    postcode_label: 'Postal code',
    postcode_pattern: 'SIQQ 1ZZ',
    required: ['City', 'Postcode'],
  },
  GT: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '01501',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  GU: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '96931',
    postcode_label: 'Zip code',
    postcode_pattern: '(969(?:[12]\\d|3[12]))(?:[ \\-](\\d{4}))?',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
  },
  GW: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1011',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  GY: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  HK: {
    city_label: 'District',
    fields: ['City', 'State'],
    required: ['State'],
    state_label: 'Area',
    state_options: [
      {
        key: 'Hong Kong Island',
        label: 'Hong Kong Island',
      },
      {
        key: 'Kowloon',
        label: 'Kowloon',
      },
      {
        key: 'New Territories',
        label: 'New Territories',
      },
    ],
  },
  HM: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '7050',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
    state_label: 'Province',
  },
  HN: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '31301',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'State'],
    state_label: 'Province',
  },
  HR: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '21001',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  HT: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '8510',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  HU: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1540',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'Postcode'],
  },
  ID: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '40115',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['State'],
    state_label: 'Province',
    state_options: [
      {
        key: 'AC',
        label: 'Aceh',
      },
      {
        key: 'BA',
        label: 'Bali',
      },
      {
        key: 'BT',
        label: 'Banten',
      },
      {
        key: 'BE',
        label: 'Bengkulu',
      },
      {
        key: 'JK',
        label: 'DKI Jakarta',
      },
      {
        key: 'YO',
        label: 'Daerah Istimewa Yogyakarta',
      },
      {
        key: 'GO',
        label: 'Gorontalo',
      },
      {
        key: 'JA',
        label: 'Jambi',
      },
      {
        key: 'JB',
        label: 'Jawa Barat',
      },
      {
        key: 'JT',
        label: 'Jawa Tengah',
      },
      {
        key: 'JI',
        label: 'Jawa Timur',
      },
      {
        key: 'KB',
        label: 'Kalimantan Barat',
      },
      {
        key: 'KS',
        label: 'Kalimantan Selatan',
      },
      {
        key: 'KT',
        label: 'Kalimantan Tengah',
      },
      {
        key: 'KI',
        label: 'Kalimantan Timur',
      },
      {
        key: 'KU',
        label: 'Kalimantan Utara',
      },
      {
        key: 'BB',
        label: 'Kepulauan Bangka Belitung',
      },
      {
        key: 'KR',
        label: 'Kepulauan Riau',
      },
      {
        key: 'LA',
        label: 'Lampung',
      },
      {
        key: 'MA',
        label: 'Maluku',
      },
      {
        key: 'MU',
        label: 'Maluku Utara',
      },
      {
        key: 'NB',
        label: 'Nusa Tenggara Barat',
      },
      {
        key: 'NT',
        label: 'Nusa Tenggara Timur',
      },
      {
        key: 'PA',
        label: 'Papua',
      },
      {
        key: 'PB',
        label: 'Papua Barat',
      },
      {
        key: 'RI',
        label: 'Riau',
      },
      {
        key: 'SR',
        label: 'Sulawesi Barat',
      },
      {
        key: 'SN',
        label: 'Sulawesi Selatan',
      },
      {
        key: 'ST',
        label: 'Sulawesi Tengah',
      },
      {
        key: 'SG',
        label: 'Sulawesi Tenggara',
      },
      {
        key: 'SA',
        label: 'Sulawesi Utara',
      },
      {
        key: 'SB',
        label: 'Sumatera Barat',
      },
      {
        key: 'SS',
        label: 'Sumatera Selatan',
      },
      {
        key: 'SU',
        label: 'Sumatera Utara',
      },
    ],
  },
  IE: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: 'A65 F4E2',
    postcode_label: 'Eircode code',
    postcode_pattern: '[\\dA-Z]{3} ?[\\dA-Z]{4}',
    required: [],
    state_label: 'County',
    state_options: [
      {
        key: 'CW',
        label: 'Co. Carlow',
      },
      {
        key: 'CN',
        label: 'Co. Cavan',
      },
      {
        key: 'CE',
        label: 'Co. Clare',
      },
      {
        key: 'C',
        label: 'Co. Cork',
      },
      {
        key: 'DL',
        label: 'Co. Donegal',
      },
      {
        key: 'D',
        label: 'Co. Dublin',
      },
      {
        key: 'G',
        label: 'Co. Galway',
      },
      {
        key: 'KY',
        label: 'Co. Kerry',
      },
      {
        key: 'KE',
        label: 'Co. Kildare',
      },
      {
        key: 'KK',
        label: 'Co. Kilkenny',
      },
      {
        key: 'LS',
        label: 'Co. Laois',
      },
      {
        key: 'LM',
        label: 'Co. Leitrim',
      },
      {
        key: 'LK',
        label: 'Co. Limerick',
      },
      {
        key: 'LD',
        label: 'Co. Longford',
      },
      {
        key: 'LH',
        label: 'Co. Louth',
      },
      {
        key: 'MO',
        label: 'Co. Mayo',
      },
      {
        key: 'MH',
        label: 'Co. Meath',
      },
      {
        key: 'MN',
        label: 'Co. Monaghan',
      },
      {
        key: 'OY',
        label: 'Co. Offaly',
      },
      {
        key: 'RN',
        label: 'Co. Roscommon',
      },
      {
        key: 'SO',
        label: 'Co. Sligo',
      },
      {
        key: 'TA',
        label: 'Co. Tipperary',
      },
      {
        key: 'WD',
        label: 'Co. Waterford',
      },
      {
        key: 'WH',
        label: 'Co. Westmeath',
      },
      {
        key: 'WX',
        label: 'Co. Wexford',
      },
      {
        key: 'WW',
        label: 'Co. Wicklow',
      },
    ],
  },
  IL: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '9614303',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}(?:\\d{2})?',
    required: [],
  },
  IM: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'IM99 1PS',
    postcode_label: 'Postal code',
    postcode_pattern: 'IM\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}',
    required: ['City', 'Postcode'],
  },
  IN: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '110001',
    postcode_label: 'Pin code',
    postcode_pattern: '\\d{6}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
    state_options: [
      {
        key: 'AN',
        label: 'Andaman & Nicobar',
      },
      {
        key: 'AP',
        label: 'Andhra Pradesh',
      },
      {
        key: 'AR',
        label: 'Arunachal Pradesh',
      },
      {
        key: 'AS',
        label: 'Assam',
      },
      {
        key: 'BR',
        label: 'Bihar',
      },
      {
        key: 'CH',
        label: 'Chandigarh',
      },
      {
        key: 'CT',
        label: 'Chhattisgarh',
      },
      {
        key: 'DN',
        label: 'Dadra & Nagar Haveli',
      },
      {
        key: 'DD',
        label: 'Daman & Diu',
      },
      {
        key: 'DL',
        label: 'Delhi',
      },
      {
        key: 'GA',
        label: 'Goa',
      },
      {
        key: 'GJ',
        label: 'Gujarat',
      },
      {
        key: 'HR',
        label: 'Haryana',
      },
      {
        key: 'HP',
        label: 'Himachal Pradesh',
      },
      {
        key: 'JK',
        label: 'Jammu & Kashmir',
      },
      {
        key: 'JH',
        label: 'Jharkhand',
      },
      {
        key: 'KA',
        label: 'Karnataka',
      },
      {
        key: 'KL',
        label: 'Kerala',
      },
      {
        key: 'LD',
        label: 'Lakshadweep',
      },
      {
        key: 'MP',
        label: 'Madhya Pradesh',
      },
      {
        key: 'MH',
        label: 'Maharashtra',
      },
      {
        key: 'MN',
        label: 'Manipur',
      },
      {
        key: 'ML',
        label: 'Meghalaya',
      },
      {
        key: 'MZ',
        label: 'Mizoram',
      },
      {
        key: 'NL',
        label: 'Nagaland',
      },
      {
        key: 'OR',
        label: 'Odisha',
      },
      {
        key: 'PY',
        label: 'Puducherry',
      },
      {
        key: 'PB',
        label: 'Punjab',
      },
      {
        key: 'RJ',
        label: 'Rajasthan',
      },
      {
        key: 'SK',
        label: 'Sikkim',
      },
      {
        key: 'TN',
        label: 'Tamil Nadu',
      },
      {
        key: 'TG',
        label: 'Telangana',
      },
      {
        key: 'TR',
        label: 'Tripura',
      },
      {
        key: 'UP',
        label: 'Uttar Pradesh',
      },
      {
        key: 'UT',
        label: 'Uttarakhand',
      },
      {
        key: 'WB',
        label: 'West Bengal',
      },
    ],
  },
  IO: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'BBND 1ZZ',
    postcode_label: 'Postal code',
    postcode_pattern: 'BBND 1ZZ',
    required: ['City', 'Postcode'],
  },
  IQ: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '31001',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'State'],
    state_label: 'Province',
  },
  IR: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '11936-12345',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}-?\\d{5}',
    required: [],
    state_label: 'Province',
  },
  IS: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '110',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3}',
    required: [],
  },
  IT: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '39049',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'Province',
    state_options: [
      {
        key: 'AG',
        label: 'Agrigento',
      },
      {
        key: 'AL',
        label: 'Alessandria',
      },
      {
        key: 'AN',
        label: 'Ancona',
      },
      {
        key: 'AO',
        label: 'Aosta',
      },
      {
        key: 'AR',
        label: 'Arezzo',
      },
      {
        key: 'AP',
        label: 'Ascoli Piceno',
      },
      {
        key: 'AT',
        label: 'Asti',
      },
      {
        key: 'AV',
        label: 'Avellino',
      },
      {
        key: 'BA',
        label: 'Bari',
      },
      {
        key: 'BT',
        label: 'Barletta-Andria-Trani',
      },
      {
        key: 'BL',
        label: 'Belluno',
      },
      {
        key: 'BN',
        label: 'Benevento',
      },
      {
        key: 'BG',
        label: 'Bergamo',
      },
      {
        key: 'BI',
        label: 'Biella',
      },
      {
        key: 'BO',
        label: 'Bologna',
      },
      {
        key: 'BZ',
        label: 'Bolzano',
      },
      {
        key: 'BS',
        label: 'Brescia',
      },
      {
        key: 'BR',
        label: 'Brindisi',
      },
      {
        key: 'CA',
        label: 'Cagliari',
      },
      {
        key: 'CL',
        label: 'Caltanissetta',
      },
      {
        key: 'CB',
        label: 'Campobasso',
      },
      {
        key: 'CI',
        label: 'Carbonia-Iglesias',
      },
      {
        key: 'CE',
        label: 'Caserta',
      },
      {
        key: 'CT',
        label: 'Catania',
      },
      {
        key: 'CZ',
        label: 'Catanzaro',
      },
      {
        key: 'CH',
        label: 'Chieti',
      },
      {
        key: 'CO',
        label: 'Como',
      },
      {
        key: 'CS',
        label: 'Cosenza',
      },
      {
        key: 'CR',
        label: 'Cremona',
      },
      {
        key: 'KR',
        label: 'Crotone',
      },
      {
        key: 'CN',
        label: 'Cuneo',
      },
      {
        key: 'EN',
        label: 'Enna',
      },
      {
        key: 'FM',
        label: 'Fermo',
      },
      {
        key: 'FE',
        label: 'Ferrara',
      },
      {
        key: 'FI',
        label: 'Firenze',
      },
      {
        key: 'FG',
        label: 'Foggia',
      },
      {
        key: 'FC',
        label: 'Forlì-Cesena',
      },
      {
        key: 'FR',
        label: 'Frosinone',
      },
      {
        key: 'GE',
        label: 'Genova',
      },
      {
        key: 'GO',
        label: 'Gorizia',
      },
      {
        key: 'GR',
        label: 'Grosseto',
      },
      {
        key: 'IM',
        label: 'Imperia',
      },
      {
        key: 'IS',
        label: 'Isernia',
      },
      {
        key: 'AQ',
        label: "L'Aquila",
      },
      {
        key: 'SP',
        label: 'La Spezia',
      },
      {
        key: 'LT',
        label: 'Latina',
      },
      {
        key: 'LE',
        label: 'Lecce',
      },
      {
        key: 'LC',
        label: 'Lecco',
      },
      {
        key: 'LI',
        label: 'Livorno',
      },
      {
        key: 'LO',
        label: 'Lodi',
      },
      {
        key: 'LU',
        label: 'Lucca',
      },
      {
        key: 'MC',
        label: 'Macerata',
      },
      {
        key: 'MN',
        label: 'Mantova',
      },
      {
        key: 'MS',
        label: 'Massa-Carrara',
      },
      {
        key: 'MT',
        label: 'Matera',
      },
      {
        key: 'VS',
        label: 'Medio Campidano',
      },
      {
        key: 'ME',
        label: 'Messina',
      },
      {
        key: 'MI',
        label: 'Milano',
      },
      {
        key: 'MO',
        label: 'Modena',
      },
      {
        key: 'MB',
        label: 'Monza e Brianza',
      },
      {
        key: 'NA',
        label: 'Napoli',
      },
      {
        key: 'NO',
        label: 'Novara',
      },
      {
        key: 'NU',
        label: 'Nuoro',
      },
      {
        key: 'OG',
        label: 'Ogliastra',
      },
      {
        key: 'OT',
        label: 'Olbia-Tempio',
      },
      {
        key: 'OR',
        label: 'Oristano',
      },
      {
        key: 'PD',
        label: 'Padova',
      },
      {
        key: 'PA',
        label: 'Palermo',
      },
      {
        key: 'PR',
        label: 'Parma',
      },
      {
        key: 'PV',
        label: 'Pavia',
      },
      {
        key: 'PG',
        label: 'Perugia',
      },
      {
        key: 'PU',
        label: 'Pesaro e Urbino',
      },
      {
        key: 'PE',
        label: 'Pescara',
      },
      {
        key: 'PC',
        label: 'Piacenza',
      },
      {
        key: 'PI',
        label: 'Pisa',
      },
      {
        key: 'PT',
        label: 'Pistoia',
      },
      {
        key: 'PN',
        label: 'Pordenone',
      },
      {
        key: 'PZ',
        label: 'Potenza',
      },
      {
        key: 'PO',
        label: 'Prato',
      },
      {
        key: 'RG',
        label: 'Ragusa',
      },
      {
        key: 'RA',
        label: 'Ravenna',
      },
      {
        key: 'RC',
        label: 'Reggio Calabria',
      },
      {
        key: 'RE',
        label: 'Reggio Emilia',
      },
      {
        key: 'RI',
        label: 'Rieti',
      },
      {
        key: 'RN',
        label: 'Rimini',
      },
      {
        key: 'RM',
        label: 'Roma',
      },
      {
        key: 'RO',
        label: 'Rovigo',
      },
      {
        key: 'SA',
        label: 'Salerno',
      },
      {
        key: 'SS',
        label: 'Sassari',
      },
      {
        key: 'SV',
        label: 'Savona',
      },
      {
        key: 'SI',
        label: 'Siena',
      },
      {
        key: 'SR',
        label: 'Siracusa',
      },
      {
        key: 'SO',
        label: 'Sondrio',
      },
      {
        key: 'TA',
        label: 'Taranto',
      },
      {
        key: 'TE',
        label: 'Teramo',
      },
      {
        key: 'TR',
        label: 'Terni',
      },
      {
        key: 'TO',
        label: 'Torino',
      },
      {
        key: 'TP',
        label: 'Trapani',
      },
      {
        key: 'TN',
        label: 'Trento',
      },
      {
        key: 'TV',
        label: 'Treviso',
      },
      {
        key: 'TS',
        label: 'Trieste',
      },
      {
        key: 'UD',
        label: 'Udine',
      },
      {
        key: 'VA',
        label: 'Varese',
      },
      {
        key: 'VE',
        label: 'Venezia',
      },
      {
        key: 'VB',
        label: 'Verbano-Cusio-Ossola',
      },
      {
        key: 'VC',
        label: 'Vercelli',
      },
      {
        key: 'VR',
        label: 'Verona',
      },
      {
        key: 'VV',
        label: 'Vibo Valentia',
      },
      {
        key: 'VI',
        label: 'Vicenza',
      },
      {
        key: 'VT',
        label: 'Viterbo',
      },
    ],
  },
  JE: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'JE2 2BT',
    postcode_label: 'Postal code',
    postcode_pattern: 'JE\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}',
    required: ['City', 'Postcode'],
  },
  JM: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: ['City', 'State'],
    state_label: 'Parish',
    state_options: [
      {
        key: '13',
        label: 'Clarendon',
      },
      {
        key: '09',
        label: 'Hanover',
      },
      {
        key: '01',
        label: 'Kingston',
      },
      {
        key: '12',
        label: 'Manchester',
      },
      {
        key: '04',
        label: 'Portland',
      },
      {
        key: '02',
        label: 'St. Andrew',
      },
      {
        key: '06',
        label: 'St. Ann',
      },
      {
        key: '14',
        label: 'St. Catherine',
      },
      {
        key: '11',
        label: 'St. Elizabeth',
      },
      {
        key: '08',
        label: 'St. James',
      },
      {
        key: '05',
        label: 'St. Mary',
      },
      {
        key: '03',
        label: 'St. Thomas',
      },
      {
        key: '07',
        label: 'Trelawny',
      },
      {
        key: '10',
        label: 'Westmoreland',
      },
    ],
  },
  JO: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '11190',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  JP: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '231-0012',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3}-?\\d{4}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'Prefecture',
    state_options: [
      {
        key: '23',
        label: 'Aichi',
      },
      {
        key: '05',
        label: 'Akita',
      },
      {
        key: '02',
        label: 'Aomori',
      },
      {
        key: '12',
        label: 'Chiba',
      },
      {
        key: '38',
        label: 'Ehime',
      },
      {
        key: '18',
        label: 'Fukui',
      },
      {
        key: '40',
        label: 'Fukuoka',
      },
      {
        key: '07',
        label: 'Fukushima',
      },
      {
        key: '21',
        label: 'Gifu',
      },
      {
        key: '10',
        label: 'Gunma',
      },
      {
        key: '34',
        label: 'Hiroshima',
      },
      {
        key: '01',
        label: 'Hokkaido',
      },
      {
        key: '28',
        label: 'Hyogo',
      },
      {
        key: '08',
        label: 'Ibaraki',
      },
      {
        key: '17',
        label: 'Ishikawa',
      },
      {
        key: '03',
        label: 'Iwate',
      },
      {
        key: '37',
        label: 'Kagawa',
      },
      {
        key: '46',
        label: 'Kagoshima',
      },
      {
        key: '14',
        label: 'Kanagawa',
      },
      {
        key: '39',
        label: 'Kochi',
      },
      {
        key: '43',
        label: 'Kumamoto',
      },
      {
        key: '26',
        label: 'Kyoto',
      },
      {
        key: '24',
        label: 'Mie',
      },
      {
        key: '04',
        label: 'Miyagi',
      },
      {
        key: '45',
        label: 'Miyazaki',
      },
      {
        key: '20',
        label: 'Nagano',
      },
      {
        key: '42',
        label: 'Nagasaki',
      },
      {
        key: '29',
        label: 'Nara',
      },
      {
        key: '15',
        label: 'Niigata',
      },
      {
        key: '44',
        label: 'Oita',
      },
      {
        key: '33',
        label: 'Okayama',
      },
      {
        key: '47',
        label: 'Okinawa',
      },
      {
        key: '27',
        label: 'Osaka',
      },
      {
        key: '41',
        label: 'Saga',
      },
      {
        key: '11',
        label: 'Saitama',
      },
      {
        key: '25',
        label: 'Shiga',
      },
      {
        key: '32',
        label: 'Shimane',
      },
      {
        key: '22',
        label: 'Shizuoka',
      },
      {
        key: '09',
        label: 'Tochigi',
      },
      {
        key: '36',
        label: 'Tokushima',
      },
      {
        key: '13',
        label: 'Tokyo',
      },
      {
        key: '31',
        label: 'Tottori',
      },
      {
        key: '16',
        label: 'Toyama',
      },
      {
        key: '30',
        label: 'Wakayama',
      },
      {
        key: '06',
        label: 'Yamagata',
      },
      {
        key: '35',
        label: 'Yamaguchi',
      },
      {
        key: '19',
        label: 'Yamanashi',
      },
    ],
  },
  KE: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '00100',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  KG: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '720001',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
  },
  KH: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '12000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  KI: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: [],
    state_label: 'Island',
  },
  KM: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  KN: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: ['City', 'State'],
    state_label: 'Island',
    state_options: [
      {
        key: 'N',
        label: 'Nevis',
      },
      {
        key: 'K',
        label: 'St. Kitts',
      },
    ],
  },
  KP: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  KR: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '03051',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'Do_si',
    state_options: [
      {
        key: '26',
        label: 'Busan',
      },
      {
        key: '43',
        label: 'Chungcheongbuk-do',
      },
      {
        key: '44',
        label: 'Chungcheongnam-do',
      },
      {
        key: '27',
        label: 'Daegu',
      },
      {
        key: '30',
        label: 'Daejeon',
      },
      {
        key: '42',
        label: 'Gangwon-do',
      },
      {
        key: '29',
        label: 'Gwangju',
      },
      {
        key: '41',
        label: 'Gyeonggi-do',
      },
      {
        key: '47',
        label: 'Gyeongsangbuk-do',
      },
      {
        key: '48',
        label: 'Gyeongsangnam-do',
      },
      {
        key: '28',
        label: 'Incheon',
      },
      {
        key: '49',
        label: 'Jeju-do',
      },
      {
        key: '45',
        label: 'Jeollabuk-do',
      },
      {
        key: '46',
        label: 'Jeollanam-do',
      },
      {
        key: '50',
        label: 'Sejong',
      },
      {
        key: '11',
        label: 'Seoul',
      },
      {
        key: '31',
        label: 'Ulsan',
      },
    ],
  },
  KW: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '13009',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  KY: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: 'KY2-2101',
    postcode_label: 'Postal code',
    postcode_pattern: 'KY\\d-\\d{4}',
    required: ['State'],
    state_label: 'Island',
    state_options: [
      {
        key: 'Cayman Brac',
        label: 'Cayman Brac',
      },
      {
        key: 'Grand Cayman',
        label: 'Grand Cayman',
      },
      {
        key: 'Little Cayman',
        label: 'Little Cayman',
      },
    ],
  },
  KZ: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '050012',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
    state_label: 'Province',
  },
  LA: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '01000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  LB: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1000',
    postcode_label: 'Postal code',
    postcode_pattern: '(?:\\d{4})(?: ?(?:\\d{4}))?',
    required: [],
  },
  LC: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  LI: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '9485',
    postcode_label: 'Postal code',
    postcode_pattern: '948[5-9]|949[0-7]',
    required: ['City', 'Postcode'],
  },
  LK: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '00100',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  LR: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  LS: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '100',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3}',
    required: [],
  },
  LT: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '03500',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  LU: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '2998',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'Postcode'],
  },
  LV: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'LV-1000',
    postcode_label: 'Postal code',
    postcode_pattern: 'LV-\\d{4}',
    required: [],
  },
  LY: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  MA: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '16052',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  MC: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '98001',
    postcode_label: 'Postal code',
    postcode_pattern: '980\\d{2}',
    required: [],
  },
  MD: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '2019',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  ME: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '85366',
    postcode_label: 'Postal code',
    postcode_pattern: '8\\d{4}',
    required: [],
  },
  MF: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '97100',
    postcode_label: 'Postal code',
    postcode_pattern: '9[78][01]\\d{2}',
    required: ['City', 'Postcode'],
  },
  MG: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '101',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3}',
    required: [],
  },
  MH: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '96970',
    postcode_label: 'Zip code',
    postcode_pattern: '(969[67]\\d)(?:[ \\-](\\d{4}))?',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
  },
  MK: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1062',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  ML: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  MM: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '11181',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  MN: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '65270',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
    state_label: 'Province',
  },
  MO: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  MP: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '96952',
    postcode_label: 'Zip code',
    postcode_pattern: '(9695[012])(?:[ \\-](\\d{4}))?',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
  },
  MQ: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '97220',
    postcode_label: 'Postal code',
    postcode_pattern: '9[78]2\\d{2}',
    required: ['City', 'Postcode'],
  },
  MR: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  MS: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  MT: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'VCT 1753',
    postcode_label: 'Postal code',
    postcode_pattern: '[A-Z]{3} ?\\d{2,4}',
    required: [],
  },
  MU: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '42602',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3}(?:\\d{2}|[A-Z]{2}\\d{3})',
    required: [],
  },
  MV: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '20026',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  MW: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  MX: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '06082',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'Postcode'],
    state_label: 'State',
    state_options: [
      {
        key: 'AGU',
        label: 'Aguascalientes',
      },
      {
        key: 'BCN',
        label: 'Baja California',
      },
      {
        key: 'BCS',
        label: 'Baja California Sur',
      },
      {
        key: 'CAM',
        label: 'Campeche',
      },
      {
        key: 'CHP',
        label: 'Chiapas',
      },
      {
        key: 'CHH',
        label: 'Chihuahua',
      },
      {
        key: 'DIF',
        label: 'Ciudad de México',
      },
      {
        key: 'COA',
        label: 'Coahuila',
      },
      {
        key: 'COL',
        label: 'Colima',
      },
      {
        key: 'DUR',
        label: 'Durango',
      },
      {
        key: 'MEX',
        label: 'Estado de México',
      },
      {
        key: 'GUA',
        label: 'Guanajuato',
      },
      {
        key: 'GRO',
        label: 'Guerrero',
      },
      {
        key: 'HID',
        label: 'Hidalgo',
      },
      {
        key: 'JAL',
        label: 'Jalisco',
      },
      {
        key: 'MIC',
        label: 'Michoacán',
      },
      {
        key: 'MOR',
        label: 'Morelos',
      },
      {
        key: 'NAY',
        label: 'Nayarit',
      },
      {
        key: 'NLE',
        label: 'Nuevo León',
      },
      {
        key: 'OAX',
        label: 'Oaxaca',
      },
      {
        key: 'PUE',
        label: 'Puebla',
      },
      {
        key: 'QUE',
        label: 'Querétaro',
      },
      {
        key: 'ROO',
        label: 'Quintana Roo',
      },
      {
        key: 'SLP',
        label: 'San Luís Potosí',
      },
      {
        key: 'SIN',
        label: 'Sinalóa',
      },
      {
        key: 'SON',
        label: 'Sonora',
      },
      {
        key: 'TAB',
        label: 'Tabasco',
      },
      {
        key: 'TAM',
        label: 'Tamaulipas',
      },
      {
        key: 'TLA',
        label: 'Tlaxcala',
      },
      {
        key: 'VER',
        label: 'Veracruz',
      },
      {
        key: 'YUC',
        label: 'Yucatán',
      },
      {
        key: 'ZAC',
        label: 'Zacatecas',
      },
    ],
  },
  MY: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '50670',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'Postcode'],
    state_label: 'State',
    state_options: [
      {
        key: '01',
        label: 'Johor',
      },
      {
        key: '02',
        label: 'Kedah',
      },
      {
        key: '03',
        label: 'Kelantan',
      },
      {
        key: '14',
        label: 'Kuala Lumpur',
      },
      {
        key: '15',
        label: 'Labuan',
      },
      {
        key: '04',
        label: 'Melaka',
      },
      {
        key: '05',
        label: 'Negeri Sembilan',
      },
      {
        key: '06',
        label: 'Pahang',
      },
      {
        key: '08',
        label: 'Perak',
      },
      {
        key: '09',
        label: 'Perlis',
      },
      {
        key: '07',
        label: 'Pulau Pinang',
      },
      {
        key: '16',
        label: 'Putrajaya',
      },
      {
        key: '12',
        label: 'Sabah',
      },
      {
        key: '13',
        label: 'Sarawak',
      },
      {
        key: '10',
        label: 'Selangor',
      },
      {
        key: '11',
        label: 'Terengganu',
      },
    ],
  },
  MZ: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '3212',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  NA: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  NC: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '98810',
    postcode_label: 'Postal code',
    postcode_pattern: '988\\d{2}',
    required: ['City', 'Postcode'],
  },
  NE: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '8001',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  NF: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '2899',
    postcode_label: 'Postal code',
    postcode_pattern: '2899',
    required: [],
    state_label: 'Province',
  },
  NG: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '931104',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
    state_label: 'State',
    state_options: [
      {
        key: 'AB',
        label: 'Abia',
      },
      {
        key: 'AD',
        label: 'Adamawa',
      },
      {
        key: 'AK',
        label: 'Akwa Ibom',
      },
      {
        key: 'AN',
        label: 'Anambra',
      },
      {
        key: 'BA',
        label: 'Bauchi',
      },
      {
        key: 'BY',
        label: 'Bayelsa',
      },
      {
        key: 'BE',
        label: 'Benue',
      },
      {
        key: 'BO',
        label: 'Borno',
      },
      {
        key: 'CR',
        label: 'Cross River',
      },
      {
        key: 'DE',
        label: 'Delta',
      },
      {
        key: 'EB',
        label: 'Ebonyi',
      },
      {
        key: 'ED',
        label: 'Edo',
      },
      {
        key: 'EK',
        label: 'Ekiti',
      },
      {
        key: 'EN',
        label: 'Enugu',
      },
      {
        key: 'FC',
        label: 'Federal Capital Territory',
      },
      {
        key: 'GO',
        label: 'Gombe',
      },
      {
        key: 'IM',
        label: 'Imo',
      },
      {
        key: 'JI',
        label: 'Jigawa',
      },
      {
        key: 'KD',
        label: 'Kaduna',
      },
      {
        key: 'KN',
        label: 'Kano',
      },
      {
        key: 'KT',
        label: 'Katsina',
      },
      {
        key: 'KE',
        label: 'Kebbi',
      },
      {
        key: 'KO',
        label: 'Kogi',
      },
      {
        key: 'KW',
        label: 'Kwara',
      },
      {
        key: 'LA',
        label: 'Lagos',
      },
      {
        key: 'NA',
        label: 'Nasarawa',
      },
      {
        key: 'NI',
        label: 'Niger',
      },
      {
        key: 'OG',
        label: 'Ogun State',
      },
      {
        key: 'ON',
        label: 'Ondo',
      },
      {
        key: 'OS',
        label: 'Osun',
      },
      {
        key: 'OY',
        label: 'Oyo',
      },
      {
        key: 'PL',
        label: 'Plateau',
      },
      {
        key: 'RI',
        label: 'Rivers',
      },
      {
        key: 'SO',
        label: 'Sokoto',
      },
      {
        key: 'TA',
        label: 'Taraba',
      },
      {
        key: 'YO',
        label: 'Yobe',
      },
      {
        key: 'ZA',
        label: 'Zamfara',
      },
    ],
  },
  NI: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '52000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
    state_label: 'Department',
    state_options: [
      {
        key: 'BO',
        label: 'Boaco',
      },
      {
        key: 'CA',
        label: 'Carazo',
      },
      {
        key: 'CI',
        label: 'Chinandega',
      },
      {
        key: 'CO',
        label: 'Chontales',
      },
      {
        key: 'ES',
        label: 'Esteli',
      },
      {
        key: 'GR',
        label: 'Granada',
      },
      {
        key: 'JI',
        label: 'Jinotega',
      },
      {
        key: 'LE',
        label: 'Leon',
      },
      {
        key: 'MD',
        label: 'Madriz',
      },
      {
        key: 'MN',
        label: 'Managua',
      },
      {
        key: 'MS',
        label: 'Masaya',
      },
      {
        key: 'MT',
        label: 'Matagalpa',
      },
      {
        key: 'NS',
        label: 'Nueva Segovia',
      },
      {
        key: 'AN',
        label: 'Raan',
      },
      {
        key: 'AS',
        label: 'Raas',
      },
      {
        key: 'SJ',
        label: 'Rio San Juan',
      },
      {
        key: 'RI',
        label: 'Rivas',
      },
    ],
  },
  NL: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '2490 AA',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4} ?[A-Z]{2}',
    required: ['City', 'Postcode'],
  },
  NO: {
    city_label: 'Post_town',
    fields: ['City', 'Postcode'],
    postcode_hint: '6631',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'Postcode'],
  },
  NP: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '44601',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  NR: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: ['State'],
    state_label: 'District',
    state_options: [
      {
        key: '01',
        label: 'Aiwo District',
      },
      {
        key: '02',
        label: 'Anabar District',
      },
      {
        key: '03',
        label: 'Anetan District',
      },
      {
        key: '04',
        label: 'Anibare District',
      },
      {
        key: '05',
        label: 'Baiti District',
      },
      {
        key: '06',
        label: 'Boe District',
      },
      {
        key: '07',
        label: 'Buada District',
      },
      {
        key: '08',
        label: 'Denigomodu District',
      },
      {
        key: '09',
        label: 'Ewa District',
      },
      {
        key: '10',
        label: 'Ijuw District',
      },
      {
        key: '11',
        label: 'Meneng District',
      },
      {
        key: '12',
        label: 'Nibok District',
      },
      {
        key: '13',
        label: 'Uaboe District',
      },
      {
        key: '14',
        label: 'Yaren District',
      },
    ],
  },
  NU: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  NZ: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '6332',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'Postcode'],
  },
  OM: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '111',
    postcode_label: 'Postal code',
    postcode_pattern: '(?:PC )?\\d{3}',
    required: [],
  },
  PA: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: [],
    state_label: 'Province',
  },
  PE: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '02001',
    postcode_label: 'Postal code',
    postcode_pattern: '(?:LIMA \\d{1,2}|CALLAO 0?\\d)|[0-2]\\d{4}',
    required: [],
    state_label: 'Province',
  },
  PF: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '98709',
    postcode_label: 'Postal code',
    postcode_pattern: '987\\d{2}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'Island',
  },
  PG: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '111',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3}',
    required: ['City', 'State'],
    state_label: 'Province',
  },
  PH: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '1000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
    state_label: 'Province',
    state_options: [
      {
        key: 'ABR',
        label: 'Abra',
      },
      {
        key: 'AGN',
        label: 'Agusan del Norte',
      },
      {
        key: 'AGS',
        label: 'Agusan del Sur',
      },
      {
        key: 'AKL',
        label: 'Aklan',
      },
      {
        key: 'ALB',
        label: 'Albay',
      },
      {
        key: 'ANT',
        label: 'Antique',
      },
      {
        key: 'APA',
        label: 'Apayao',
      },
      {
        key: 'AUR',
        label: 'Aurora',
      },
      {
        key: 'BAS',
        label: 'Basilan',
      },
      {
        key: 'BAN',
        label: 'Bataan',
      },
      {
        key: 'BTN',
        label: 'Batanes',
      },
      {
        key: 'BTG',
        label: 'Batangas',
      },
      {
        key: 'BEN',
        label: 'Benguet',
      },
      {
        key: 'BIL',
        label: 'Biliran',
      },
      {
        key: 'BOH',
        label: 'Bohol',
      },
      {
        key: 'BUK',
        label: 'Bukidnon',
      },
      {
        key: 'BUL',
        label: 'Bulacan',
      },
      {
        key: 'CAG',
        label: 'Cagayan',
      },
      {
        key: 'CAN',
        label: 'Camarines Norte',
      },
      {
        key: 'CAS',
        label: 'Camarines Sur',
      },
      {
        key: 'CAM',
        label: 'Camiguin',
      },
      {
        key: 'CAP',
        label: 'Capiz',
      },
      {
        key: 'CAT',
        label: 'Catanduanes',
      },
      {
        key: 'CAV',
        label: 'Cavite',
      },
      {
        key: 'CEB',
        label: 'Cebu',
      },
      {
        key: 'COM',
        label: 'Compostela Valley',
      },
      {
        key: 'NCO',
        label: 'Cotabato',
      },
      {
        key: 'Davao Occidental',
        label: 'Davao Occidental',
      },
      {
        key: 'DAO',
        label: 'Davao Oriental',
      },
      {
        key: 'DAV',
        label: 'Davao del Norte',
      },
      {
        key: 'DAS',
        label: 'Davao del Sur',
      },
      {
        key: 'DIN',
        label: 'Dinagat Islands',
      },
      {
        key: 'EAS',
        label: 'Eastern Samar',
      },
      {
        key: 'GUI',
        label: 'Guimaras',
      },
      {
        key: 'IFU',
        label: 'Ifugao',
      },
      {
        key: 'ILN',
        label: 'Ilocos Norte',
      },
      {
        key: 'ILS',
        label: 'Ilocos Sur',
      },
      {
        key: 'ILI',
        label: 'Iloilo',
      },
      {
        key: 'ISA',
        label: 'Isabela',
      },
      {
        key: 'KAL',
        label: 'Kalinga',
      },
      {
        key: 'LUN',
        label: 'La Union',
      },
      {
        key: 'LAG',
        label: 'Laguna',
      },
      {
        key: 'LAN',
        label: 'Lanao del Norte',
      },
      {
        key: 'LAS',
        label: 'Lanao del Sur',
      },
      {
        key: 'LEY',
        label: 'Leyte',
      },
      {
        key: 'MAG',
        label: 'Maguindanao',
      },
      {
        key: 'MAD',
        label: 'Marinduque',
      },
      {
        key: 'MAS',
        label: 'Masbate',
      },
      {
        key: '00',
        label: 'Metro Manila',
      },
      {
        key: 'MDC',
        label: 'Mindoro Occidental',
      },
      {
        key: 'MDR',
        label: 'Mindoro Oriental',
      },
      {
        key: 'MSC',
        label: 'Misamis Occidental',
      },
      {
        key: 'MSR',
        label: 'Misamis Oriental',
      },
      {
        key: 'MOU',
        label: 'Mountain Province',
      },
      {
        key: 'NEC',
        label: 'Negros Occidental',
      },
      {
        key: 'NER',
        label: 'Negros Oriental',
      },
      {
        key: 'NSA',
        label: 'Northern Samar',
      },
      {
        key: 'NUE',
        label: 'Nueva Ecija',
      },
      {
        key: 'NUV',
        label: 'Nueva Vizcaya',
      },
      {
        key: 'PLW',
        label: 'Palawan',
      },
      {
        key: 'PAM',
        label: 'Pampanga',
      },
      {
        key: 'PAN',
        label: 'Pangasinan',
      },
      {
        key: 'QUE',
        label: 'Quezon Province',
      },
      {
        key: 'QUI',
        label: 'Quirino',
      },
      {
        key: 'RIZ',
        label: 'Rizal',
      },
      {
        key: 'ROM',
        label: 'Romblon',
      },
      {
        key: 'WSA',
        label: 'Samar',
      },
      {
        key: 'SAR',
        label: 'Sarangani',
      },
      {
        key: 'SIG',
        label: 'Siquijor',
      },
      {
        key: 'SOR',
        label: 'Sorsogon',
      },
      {
        key: 'SCO',
        label: 'South Cotabato',
      },
      {
        key: 'SLE',
        label: 'Southern Leyte',
      },
      {
        key: 'SUK',
        label: 'Sultan Kudarat',
      },
      {
        key: 'SLU',
        label: 'Sulu',
      },
      {
        key: 'SUN',
        label: 'Surigao del Norte',
      },
      {
        key: 'SUR',
        label: 'Surigao del Sur',
      },
      {
        key: 'TAR',
        label: 'Tarlac',
      },
      {
        key: 'TAW',
        label: 'Tawi-Tawi',
      },
      {
        key: 'ZMB',
        label: 'Zambales',
      },
      {
        key: 'ZSI',
        label: 'Zamboanga Sibuguey',
      },
      {
        key: 'ZAN',
        label: 'Zamboanga del Norte',
      },
      {
        key: 'ZAS',
        label: 'Zamboanga del Sur',
      },
    ],
  },
  PK: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '44000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  PL: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '00-940',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{2}-\\d{3}',
    required: ['City', 'Postcode'],
  },
  PM: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '97500',
    postcode_label: 'Postal code',
    postcode_pattern: '9[78]5\\d{2}',
    required: ['City', 'Postcode'],
  },
  PN: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'PCRN 1ZZ',
    postcode_label: 'Postal code',
    postcode_pattern: 'PCRN 1ZZ',
    required: ['City', 'Postcode'],
  },
  PR: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '00930',
    postcode_label: 'Zip code',
    postcode_pattern: '(00[679]\\d{2})(?:[ \\-](\\d{4}))?',
    required: ['City', 'Postcode'],
  },
  PS: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  PT: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1208-148',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}-\\d{3}',
    required: ['City', 'Postcode'],
  },
  PW: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '96940',
    postcode_label: 'Zip code',
    postcode_pattern: '(969(?:39|40))(?:[ \\-](\\d{4}))?',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
  },
  PY: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1209',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  QA: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  RE: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '97400',
    postcode_label: 'Postal code',
    postcode_pattern: '9[78]4\\d{2}',
    required: ['City', 'Postcode'],
  },
  RO: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '200716',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
  },
  RS: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '106314',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5,6}',
    required: [],
  },
  RU: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '188300',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'Oblast',
    state_options: [
      {
        key: 'AL',
        label: 'Altay Republits',
      },
      {
        key: 'ALT',
        label: 'Altayskiy kray',
      },
      {
        key: 'AMU',
        label: "Amurskaya oblast'",
      },
      {
        key: 'ARK',
        label: "Arkhangelskaya oblast'",
      },
      {
        key: 'AST',
        label: "Astrakhanskaya oblast'",
      },
      {
        key: 'BA',
        label: 'Bashkortostan Republits',
      },
      {
        key: 'BEL',
        label: "Belgorodskaya oblast'",
      },
      {
        key: 'BRY',
        label: "Bryanskaya oblast'",
      },
      {
        key: 'BU',
        label: 'Buryatiya Republits',
      },
      {
        key: 'CE',
        label: 'Chechenskaya Republits',
      },
      {
        key: 'CHE',
        label: "Chelyabinskaya oblast'",
      },
      {
        key: 'CHU',
        label: 'Chukotskiy',
      },
      {
        key: 'CU',
        label: 'Chuvashia',
      },
      {
        key: 'DA',
        label: 'Dagestan Republits',
      },
      {
        key: 'YEV',
        label: "Evreyskaya avtonomnaya oblast'",
      },
      {
        key: 'IN',
        label: 'Ingushetiya Republits',
      },
      {
        key: 'IRK',
        label: "Irkutskaya oblast'",
      },
      {
        key: 'IVA',
        label: "Ivanovskaya oblast'",
      },
      {
        key: 'KB',
        label: 'Kabardino-Balkarskaya Republits',
      },
      {
        key: 'KGD',
        label: "Kaliningradskaya oblast'",
      },
      {
        key: 'KLU',
        label: "Kaluzhskaya oblast'",
      },
      {
        key: 'KAM',
        label: 'Kamchatskiy kray',
      },
      {
        key: 'KC',
        label: 'Karachaevo-Cherkesskaya Republits',
      },
      {
        key: 'KR',
        label: 'Kareliya Republits',
      },
      {
        key: 'KEM',
        label: "Kemerovskaya oblast'",
      },
      {
        key: 'KHA',
        label: 'Khabarovskiy kray',
      },
      {
        key: 'KK',
        label: 'Khakasiya Republits',
      },
      {
        key: 'KHM',
        label: 'Khanty-Mansiyskiy avtonomnyy okrug',
      },
      {
        key: 'KIR',
        label: "Kirovskaya oblast'",
      },
      {
        key: 'KO',
        label: 'Komi Republits',
      },
      {
        key: 'KOS',
        label: "Kostromskaya oblast'",
      },
      {
        key: 'KDA',
        label: 'Krasnodarskiy kray',
      },
      {
        key: 'KYA',
        label: 'Krasnoyarskiy kray',
      },
      {
        key: 'KGN',
        label: "Kurganskaya oblast'",
      },
      {
        key: 'KRS',
        label: "Kurskaya oblast'",
      },
      {
        key: 'LEN',
        label: "Leningradskaya oblast'",
      },
      {
        key: 'LIP',
        label: "Lipetskaya oblast'",
      },
      {
        key: 'MAG',
        label: "Magadanskaya oblast'",
      },
      {
        key: 'MOS',
        label: "Moskovskaya oblast'",
      },
      {
        key: 'MUR',
        label: "Murmanskaya oblast'",
      },
      {
        key: 'NEN',
        label: 'Nenetskiy',
      },
      {
        key: 'NIZ',
        label: "Nizhegorodskaya oblast'",
      },
      {
        key: 'NGR',
        label: "Novgorodskaya oblast'",
      },
      {
        key: 'NVS',
        label: "Novosibirskaya oblast'",
      },
      {
        key: 'OMS',
        label: "Omskaya oblast'",
      },
      {
        key: 'ORE',
        label: "Orenburgskaya oblast'",
      },
      {
        key: 'ORL',
        label: "Orlovskaya oblast'",
      },
      {
        key: 'PNZ',
        label: "Penzenskaya oblast'",
      },
      {
        key: 'PER',
        label: 'Permskiy kray',
      },
      {
        key: 'PRI',
        label: 'Primorskiy kray',
      },
      {
        key: 'PSK',
        label: "Pskovskaya oblast'",
      },
      {
        key: 'AD',
        label: 'Respublika Adygeya',
      },
      {
        key: 'KL',
        label: 'Respublika Kalmykiya',
      },
      {
        key: 'Respublika Krym',
        label: 'Respublika Krym',
      },
      {
        key: 'ME',
        label: 'Respublika Mariy El',
      },
      {
        key: 'MO',
        label: 'Respublika Mordoviya',
      },
      {
        key: 'SE',
        label: 'Respublika Severnaya Osetiya-Alaniya',
      },
      {
        key: 'TA',
        label: 'Respublika Tatarstan',
      },
      {
        key: 'UD',
        label: 'Respublika Udmurtiya',
      },
      {
        key: 'ROS',
        label: "Rostovskaya oblast'",
      },
      {
        key: 'RYA',
        label: "Ryazanskaya oblast'",
      },
      {
        key: 'SA',
        label: 'Sakha (Yakutiya) Republits',
      },
      {
        key: 'SAK',
        label: "Sakhalinskaya oblast'",
      },
      {
        key: 'SAM',
        label: "Samarskaya oblast'",
      },
      {
        key: 'SAR',
        label: "Saratovskaya oblast'",
      },
      {
        key: 'SMO',
        label: "Smolenskaya oblast'",
      },
      {
        key: 'STA',
        label: 'Stavropolskiy kray',
      },
      {
        key: 'SVE',
        label: "Sverdlovskaya oblast'",
      },
      {
        key: 'TAM',
        label: "Tambovskaya oblast'",
      },
      {
        key: 'TOM',
        label: "Tomskaya oblast'",
      },
      {
        key: 'TUL',
        label: "Tulskaya oblast'",
      },
      {
        key: 'TVE',
        label: "Tverskaya oblast'",
      },
      {
        key: 'TYU',
        label: "Tyumenskaya oblast'",
      },
      {
        key: 'TY',
        label: 'Tyva Republits',
      },
      {
        key: 'ULY',
        label: "Ulyanovskaya oblast'",
      },
      {
        key: 'VLA',
        label: "Vladimirskaya oblast'",
      },
      {
        key: 'VGG',
        label: "Volgogradskaya oblast'",
      },
      {
        key: 'VLG',
        label: "Vologodskaya oblast'",
      },
      {
        key: 'VOR',
        label: "Voronezhskaya oblast'",
      },
      {
        key: 'YAN',
        label: 'Yamalo-Nenetskiy',
      },
      {
        key: 'YAR',
        label: "Yaroslavskaya oblast'",
      },
      {
        key: 'ZAB',
        label: 'Zabaykalskiy kray',
      },
      {
        key: 'MOW',
        label: 'gorod Moskva',
      },
      {
        key: 'SPE',
        label: 'gorod Sankt-Peterburg',
      },
      {
        key: "gorod Sevastopol'",
        label: "gorod Sevastopol'",
      },
    ],
  },
  RW: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  SA: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '11142',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  SB: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  SC: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: [],
    state_label: 'Island',
  },
  SD: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  SE: {
    city_label: 'Post_town',
    fields: ['City', 'Postcode'],
    postcode_hint: '11455',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3} ?\\d{2}',
    required: ['City', 'Postcode'],
  },
  SG: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '408600',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: ['Postcode'],
  },
  SH: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'STHL 1ZZ',
    postcode_label: 'Postal code',
    postcode_pattern: '(?:ASCN|STHL) 1ZZ',
    required: ['City', 'Postcode'],
  },
  SI: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '2500',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  SJ: {
    city_label: 'Post_town',
    fields: ['City', 'Postcode'],
    postcode_hint: '9170',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'Postcode'],
  },
  SK: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '975 99',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3} ?\\d{2}',
    required: [],
  },
  SL: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  SM: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '47899',
    postcode_label: 'Postal code',
    postcode_pattern: '4789\\d',
    required: ['Postcode'],
  },
  SN: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '10000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  SO: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: 'AD 11010',
    postcode_label: 'Postal code',
    postcode_pattern: '[A-Z]{2} ?\\d{5}',
    required: ['City', 'State'],
    state_label: 'Province',
    state_options: [
      {
        key: 'AW',
        label: 'Awdal',
      },
      {
        key: 'BK',
        label: 'Bakool',
      },
      {
        key: 'BN',
        label: 'Banaadir',
      },
      {
        key: 'BR',
        label: 'Bari',
      },
      {
        key: 'BY',
        label: 'Bay',
      },
      {
        key: 'GA',
        label: 'Galguduud',
      },
      {
        key: 'GE',
        label: 'Gedo',
      },
      {
        key: 'HI',
        label: 'Hiiraan',
      },
      {
        key: 'JD',
        label: 'Jubbada Dhexe',
      },
      {
        key: 'JH',
        label: 'Jubbada Hoose',
      },
      {
        key: 'MU',
        label: 'Mudug',
      },
      {
        key: 'NU',
        label: 'Nugaal',
      },
      {
        key: 'SA',
        label: 'Sanaag',
      },
      {
        key: 'SD',
        label: 'Shabeellaha Dhexe',
      },
      {
        key: 'SH',
        label: 'Shabeellaha Hoose',
      },
      {
        key: 'SO',
        label: 'Sool',
      },
      {
        key: 'TO',
        label: 'Togdheer',
      },
      {
        key: 'WO',
        label: 'Woqooyi Galbeed',
      },
    ],
  },
  SR: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: [],
    state_label: 'Province',
    state_options: [
      {
        key: 'BR',
        label: 'Brokopondo',
      },
      {
        key: 'CM',
        label: 'Commewijne',
      },
      {
        key: 'CR',
        label: 'Coronie',
      },
      {
        key: 'MA',
        label: 'Marowijne',
      },
      {
        key: 'NI',
        label: 'Nickerie',
      },
      {
        key: 'PR',
        label: 'Para',
      },
      {
        key: 'PM',
        label: 'Paramaribo',
      },
      {
        key: 'SA',
        label: 'Saramacca',
      },
      {
        key: 'SI',
        label: 'Sipaliwini',
      },
      {
        key: 'WA',
        label: 'Wanica',
      },
    ],
  },
  SS: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  ST: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  SV: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: 'CP 1101',
    postcode_label: 'Postal code',
    postcode_pattern: 'CP [1-3][1-7][0-2]\\d',
    required: ['City', 'State'],
    state_label: 'Province',
    state_options: [
      {
        key: 'AH',
        label: 'Ahuachapán',
      },
      {
        key: 'CA',
        label: 'Cabañas',
      },
      {
        key: 'CH',
        label: 'Chalatenango',
      },
      {
        key: 'CU',
        label: 'Cuscatlán',
      },
      {
        key: 'LI',
        label: 'La Libertad',
      },
      {
        key: 'PA',
        label: 'La Paz',
      },
      {
        key: 'UN',
        label: 'La Unión',
      },
      {
        key: 'MO',
        label: 'Morazán',
      },
      {
        key: 'SM',
        label: 'San Miguel',
      },
      {
        key: 'SS',
        label: 'San Salvador',
      },
      {
        key: 'SV',
        label: 'San Vicente',
      },
      {
        key: 'SA',
        label: 'Santa Ana',
      },
      {
        key: 'SO',
        label: 'Sonsonate',
      },
      {
        key: 'US',
        label: 'Usulután',
      },
    ],
  },
  SX: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  SY: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  SZ: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'H100',
    postcode_label: 'Postal code',
    postcode_pattern: '[HLMS]\\d{3}',
    required: [],
  },
  TC: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'TKCA 1ZZ',
    postcode_label: 'Postal code',
    postcode_pattern: 'TKCA 1ZZ',
    required: ['City', 'Postcode'],
  },
  TD: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  TF: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  TG: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  TH: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '10210',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
    state_label: 'Province',
    state_options: [
      {
        key: '37',
        label: 'Amnat Charoen',
      },
      {
        key: '15',
        label: 'Ang Thong',
      },
      {
        key: '10',
        label: 'Bangkok',
      },
      {
        key: '38',
        label: 'Bueng Kan',
      },
      {
        key: '31',
        label: 'Buri Ram',
      },
      {
        key: '24',
        label: 'Chachoengsao',
      },
      {
        key: '18',
        label: 'Chai Nat',
      },
      {
        key: '36',
        label: 'Chaiyaphum',
      },
      {
        key: '22',
        label: 'Chanthaburi',
      },
      {
        key: '50',
        label: 'Chiang Mai',
      },
      {
        key: '57',
        label: 'Chiang Rai',
      },
      {
        key: '20',
        label: 'Chon Buri',
      },
      {
        key: '86',
        label: 'Chumpon',
      },
      {
        key: '46',
        label: 'Kalasin',
      },
      {
        key: '62',
        label: 'Kamphaeng Phet',
      },
      {
        key: '71',
        label: 'Kanchanaburi',
      },
      {
        key: '40',
        label: 'Khon Kaen',
      },
      {
        key: '81',
        label: 'Krabi',
      },
      {
        key: '52',
        label: 'Lampang',
      },
      {
        key: '51',
        label: 'Lamphun',
      },
      {
        key: '42',
        label: 'Loei',
      },
      {
        key: '16',
        label: 'Lop Buri',
      },
      {
        key: '58',
        label: 'Mae Hong Son',
      },
      {
        key: '44',
        label: 'Maha Sarakham',
      },
      {
        key: '49',
        label: 'Mukdahan',
      },
      {
        key: '26',
        label: 'Nakhon Nayok',
      },
      {
        key: '73',
        label: 'Nakhon Pathom',
      },
      {
        key: '48',
        label: 'Nakhon Phanom',
      },
      {
        key: '30',
        label: 'Nakhon Ratchasima',
      },
      {
        key: '60',
        label: 'Nakhon Sawan',
      },
      {
        key: '80',
        label: 'Nakhon Si Thammarat',
      },
      {
        key: '55',
        label: 'Nan',
      },
      {
        key: '96',
        label: 'Narathiwat',
      },
      {
        key: '39',
        label: 'Nong Bua Lam Phu',
      },
      {
        key: '43',
        label: 'Nong Khai',
      },
      {
        key: '12',
        label: 'Nonthaburi',
      },
      {
        key: '13',
        label: 'Pathum Thani',
      },
      {
        key: '94',
        label: 'Pattani',
      },
      {
        key: '82',
        label: 'Phang Nga',
      },
      {
        key: '93',
        label: 'Phattalung',
      },
      {
        key: '56',
        label: 'Phayao',
      },
      {
        key: '67',
        label: 'Phetchabun',
      },
      {
        key: '76',
        label: 'Phetchaburi',
      },
      {
        key: '66',
        label: 'Phichit',
      },
      {
        key: '65',
        label: 'Phitsanulok',
      },
      {
        key: '14',
        label: 'Phra Nakhon Si Ayutthaya',
      },
      {
        key: '54',
        label: 'Phrae',
      },
      {
        key: '83',
        label: 'Phuket',
      },
      {
        key: '25',
        label: 'Prachin Buri',
      },
      {
        key: '77',
        label: 'Prachuap Khiri Khan',
      },
      {
        key: '85',
        label: 'Ranong',
      },
      {
        key: '70',
        label: 'Ratchaburi',
      },
      {
        key: '21',
        label: 'Rayong',
      },
      {
        key: '45',
        label: 'Roi Et',
      },
      {
        key: '27',
        label: 'Sa Kaeo',
      },
      {
        key: '47',
        label: 'Sakon Nakhon',
      },
      {
        key: '11',
        label: 'Samut Prakan',
      },
      {
        key: '74',
        label: 'Samut Sakhon',
      },
      {
        key: '75',
        label: 'Samut Songkhram',
      },
      {
        key: '19',
        label: 'Saraburi',
      },
      {
        key: '91',
        label: 'Satun',
      },
      {
        key: '33',
        label: 'Si Sa Ket',
      },
      {
        key: '17',
        label: 'Sing Buri',
      },
      {
        key: '90',
        label: 'Songkhla',
      },
      {
        key: '64',
        label: 'Sukhothai',
      },
      {
        key: '72',
        label: 'Suphanburi',
      },
      {
        key: '84',
        label: 'Surat Thani',
      },
      {
        key: '32',
        label: 'Surin',
      },
      {
        key: '63',
        label: 'Tak',
      },
      {
        key: '92',
        label: 'Trang',
      },
      {
        key: '23',
        label: 'Trat',
      },
      {
        key: '34',
        label: 'Ubon Ratchathani',
      },
      {
        key: '41',
        label: 'Udon Thani',
      },
      {
        key: '61',
        label: 'Uthai Thani',
      },
      {
        key: '53',
        label: 'Uttaradit',
      },
      {
        key: '95',
        label: 'Yala',
      },
      {
        key: '35',
        label: 'Yasothon',
      },
    ],
  },
  TJ: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '734025',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
  },
  TK: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  TL: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  TM: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '744000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
  },
  TN: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1030',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: [],
  },
  TO: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  TR: {
    city_label: 'District',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '06101',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'Postcode'],
    state_label: 'Province',
    state_options: [
      {
        key: '01',
        label: 'Adana',
      },
      {
        key: '02',
        label: 'Adıyaman',
      },
      {
        key: '03',
        label: 'Afyon',
      },
      {
        key: '68',
        label: 'Aksaray',
      },
      {
        key: '05',
        label: 'Amasya',
      },
      {
        key: '06',
        label: 'Ankara',
      },
      {
        key: '07',
        label: 'Antalya',
      },
      {
        key: '75',
        label: 'Ardahan',
      },
      {
        key: '08',
        label: 'Artvin',
      },
      {
        key: '09',
        label: 'Aydın',
      },
      {
        key: '04',
        label: 'Ağrı',
      },
      {
        key: '10',
        label: 'Balıkesir',
      },
      {
        key: '74',
        label: 'Bartın',
      },
      {
        key: '72',
        label: 'Batman',
      },
      {
        key: '69',
        label: 'Bayburt',
      },
      {
        key: '11',
        label: 'Bilecik',
      },
      {
        key: '12',
        label: 'Bingöl',
      },
      {
        key: '13',
        label: 'Bitlis',
      },
      {
        key: '14',
        label: 'Bolu',
      },
      {
        key: '15',
        label: 'Burdur',
      },
      {
        key: '16',
        label: 'Bursa',
      },
      {
        key: '20',
        label: 'Denizli',
      },
      {
        key: '21',
        label: 'Diyarbakır',
      },
      {
        key: '81',
        label: 'Düzce',
      },
      {
        key: '22',
        label: 'Edirne',
      },
      {
        key: '23',
        label: 'Elazığ',
      },
      {
        key: '24',
        label: 'Erzincan',
      },
      {
        key: '25',
        label: 'Erzurum',
      },
      {
        key: '26',
        label: 'Eskişehir',
      },
      {
        key: '27',
        label: 'Gaziantep',
      },
      {
        key: '28',
        label: 'Giresun',
      },
      {
        key: '29',
        label: 'Gümüşhane',
      },
      {
        key: '30',
        label: 'Hakkari',
      },
      {
        key: '31',
        label: 'Hatay',
      },
      {
        key: '32',
        label: 'Isparta',
      },
      {
        key: '76',
        label: 'Iğdır',
      },
      {
        key: '46',
        label: 'Kahramanmaraş',
      },
      {
        key: '78',
        label: 'Karabük',
      },
      {
        key: '70',
        label: 'Karaman',
      },
      {
        key: '36',
        label: 'Kars',
      },
      {
        key: '37',
        label: 'Kastamonu',
      },
      {
        key: '38',
        label: 'Kayseri',
      },
      {
        key: '79',
        label: 'Kilis',
      },
      {
        key: '41',
        label: 'Kocaeli',
      },
      {
        key: '42',
        label: 'Konya',
      },
      {
        key: '43',
        label: 'Kütahya',
      },
      {
        key: '39',
        label: 'Kırklareli',
      },
      {
        key: '71',
        label: 'Kırıkkale',
      },
      {
        key: '40',
        label: 'Kırşehir',
      },
      {
        key: '44',
        label: 'Malatya',
      },
      {
        key: '45',
        label: 'Manisa',
      },
      {
        key: '47',
        label: 'Mardin',
      },
      {
        key: '33',
        label: 'Mersin',
      },
      {
        key: '48',
        label: 'Muğla',
      },
      {
        key: '49',
        label: 'Muş',
      },
      {
        key: '50',
        label: 'Nevşehir',
      },
      {
        key: '51',
        label: 'Niğde',
      },
      {
        key: '52',
        label: 'Ordu',
      },
      {
        key: '80',
        label: 'Osmaniye',
      },
      {
        key: '53',
        label: 'Rize',
      },
      {
        key: '54',
        label: 'Sakarya',
      },
      {
        key: '55',
        label: 'Samsun',
      },
      {
        key: '56',
        label: 'Siirt',
      },
      {
        key: '57',
        label: 'Sinop',
      },
      {
        key: '58',
        label: 'Sivas',
      },
      {
        key: '59',
        label: 'Tekirdağ',
      },
      {
        key: '60',
        label: 'Tokat',
      },
      {
        key: '61',
        label: 'Trabzon',
      },
      {
        key: '62',
        label: 'Tunceli',
      },
      {
        key: '64',
        label: 'Uşak',
      },
      {
        key: '65',
        label: 'Van',
      },
      {
        key: '77',
        label: 'Yalova',
      },
      {
        key: '66',
        label: 'Yozgat',
      },
      {
        key: '67',
        label: 'Zonguldak',
      },
      {
        key: '17',
        label: 'Çanakkale',
      },
      {
        key: '18',
        label: 'Çankırı',
      },
      {
        key: '19',
        label: 'Çorum',
      },
      {
        key: '34',
        label: 'İstanbul',
      },
      {
        key: '35',
        label: 'İzmir',
      },
      {
        key: '63',
        label: 'Şanlıurfa',
      },
      {
        key: '73',
        label: 'Şırnak',
      },
    ],
  },
  TT: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  TV: {
    city_label: 'City',
    fields: ['City', 'State'],
    required: [],
    state_label: 'Island',
    state_options: [
      {
        key: 'FUN',
        label: 'Funafuti',
      },
      {
        key: 'NMG',
        label: 'Nanumanga',
      },
      {
        key: 'NMA',
        label: 'Nanumea',
      },
      {
        key: 'Niulakita',
        label: 'Niulakita',
      },
      {
        key: 'NIT',
        label: 'Niutao',
      },
      {
        key: 'NUI',
        label: 'Nui',
      },
      {
        key: 'NKF',
        label: 'Nukufetau',
      },
      {
        key: 'NKL',
        label: 'Nukulaelae',
      },
      {
        key: 'VAI',
        label: 'Vaitupu',
      },
    ],
  },
  TW: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '40867',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{3}(?:\\d{2})?',
    required: ['City', 'State', 'Postcode'],
    state_label: 'County',
    state_options: [
      {
        key: 'CHA',
        label: 'Changhua County',
      },
      {
        key: 'CYI',
        label: 'Chiayi City',
      },
      {
        key: 'CYQ',
        label: 'Chiayi County',
      },
      {
        key: 'HSZ',
        label: 'Hsinchu City',
      },
      {
        key: 'HSQ',
        label: 'Hsinchu County',
      },
      {
        key: 'HUA',
        label: 'Hualien County',
      },
      {
        key: 'KHH',
        label: 'Kaohsiung City',
      },
      {
        key: 'KEE',
        label: 'Keelung City',
      },
      {
        key: 'Kinmen County',
        label: 'Kinmen County',
      },
      {
        key: 'Lienchiang County',
        label: 'Lienchiang County',
      },
      {
        key: 'MIA',
        label: 'Miaoli County',
      },
      {
        key: 'NAN',
        label: 'Nantou County',
      },
      {
        key: 'NWT',
        label: 'New Taipei City',
      },
      {
        key: 'PEN',
        label: 'Penghu County',
      },
      {
        key: 'PIF',
        label: 'Pingtung County',
      },
      {
        key: 'TXG',
        label: 'Taichung City',
      },
      {
        key: 'TNN',
        label: 'Tainan City',
      },
      {
        key: 'TPE',
        label: 'Taipei City',
      },
      {
        key: 'TTT',
        label: 'Taitung County',
      },
      {
        key: 'TAO',
        label: 'Taoyuan City',
      },
      {
        key: 'ILA',
        label: 'Yilan County',
      },
      {
        key: 'YUN',
        label: 'Yunlin County',
      },
    ],
  },
  TZ: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '34413',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4,5}',
    required: [],
  },
  UA: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '01001',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: ['City', 'State', 'Postcode'],
    state_label: 'Oblast',
    state_options: [
      {
        key: 'Черкаська область',
        label: "Cherkas'ka oblast",
      },
      {
        key: 'Чернігівська область',
        label: "Chernihivs'ka oblast",
      },
      {
        key: 'Чернівецька область',
        label: "Chernivets'ka oblast",
      },
      {
        key: 'Автономна Республіка Крим',
        label: 'Crimea',
      },
      {
        key: 'Дніпропетровська область',
        label: 'Dnipropetrovsk oblast',
      },
      {
        key: 'Донецька область',
        label: 'Donetsk oblast',
      },
      {
        key: 'Івано-Франківська область',
        label: "Ivano-Frankivs'ka oblast",
      },
      {
        key: 'Харківська область',
        label: 'Kharkiv oblast',
      },
      {
        key: 'Херсонська область',
        label: "Khersons'ka oblast",
      },
      {
        key: 'Хмельницька область',
        label: "Khmel'nyts'ka oblast",
      },
      {
        key: 'Київська область',
        label: 'Kiev oblast',
      },
      {
        key: 'Кіровоградська область',
        label: "Kirovohrads'ka oblast",
      },
      {
        key: 'місто Київ',
        label: 'Kyiv city',
      },
      {
        key: 'Луганська область',
        label: "Luhans'ka oblast",
      },
      {
        key: 'Львівська область',
        label: 'Lviv oblast',
      },
      {
        key: 'Миколаївська область',
        label: "Mykolaivs'ka oblast",
      },
      {
        key: 'Одеська область',
        label: 'Odessa oblast',
      },
      {
        key: 'Полтавська область',
        label: "Poltavs'ka oblast",
      },
      {
        key: 'Рівненська область',
        label: "Rivnens'ka oblast",
      },
      {
        key: 'місто Севастополь',
        label: "Sevastopol' city",
      },
      {
        key: 'Сумська область',
        label: "Sums'ka oblast",
      },
      {
        key: 'Тернопільська область',
        label: "Ternopil's'ka oblast",
      },
      {
        key: 'Вінницька область',
        label: "Vinnyts'ka oblast",
      },
      {
        key: 'Волинська область',
        label: "Volyns'ka oblast",
      },
      {
        key: 'Закарпатська область',
        label: "Zakarpats'ka oblast",
      },
      {
        key: 'Запорізька область',
        label: "Zaporiz'ka oblast",
      },
      {
        key: 'Житомирська область',
        label: "Zhytomyrs'ka oblast",
      },
    ],
  },
  UG: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  UM: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '96898',
    postcode_label: 'Zip code',
    postcode_pattern: '96898',
    required: ['City', 'State'],
    state_label: 'State',
  },
  US: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '95014',
    postcode_label: 'Zip code',
    postcode_pattern: '(\\d{5})(?:[ \\-](\\d{4}))?',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
    state_options: [
      {
        key: 'AL',
        label: 'Alabama',
      },
      {
        key: 'AK',
        label: 'Alaska',
      },
      {
        key: 'AS',
        label: 'American Samoa',
      },
      {
        key: 'AZ',
        label: 'Arizona',
      },
      {
        key: 'AR',
        label: 'Arkansas',
      },
      {
        key: 'AA',
        label: 'Armed Forces (AA)',
      },
      {
        key: 'AE',
        label: 'Armed Forces (AE)',
      },
      {
        key: 'AP',
        label: 'Armed Forces (AP)',
      },
      {
        key: 'CA',
        label: 'California',
      },
      {
        key: 'CO',
        label: 'Colorado',
      },
      {
        key: 'CT',
        label: 'Connecticut',
      },
      {
        key: 'DE',
        label: 'Delaware',
      },
      {
        key: 'DC',
        label: 'District of Columbia',
      },
      {
        key: 'FL',
        label: 'Florida',
      },
      {
        key: 'GA',
        label: 'Georgia',
      },
      {
        key: 'GU',
        label: 'Guam',
      },
      {
        key: 'HI',
        label: 'Hawaii',
      },
      {
        key: 'ID',
        label: 'Idaho',
      },
      {
        key: 'IL',
        label: 'Illinois',
      },
      {
        key: 'IN',
        label: 'Indiana',
      },
      {
        key: 'IA',
        label: 'Iowa',
      },
      {
        key: 'KS',
        label: 'Kansas',
      },
      {
        key: 'KY',
        label: 'Kentucky',
      },
      {
        key: 'LA',
        label: 'Louisiana',
      },
      {
        key: 'ME',
        label: 'Maine',
      },
      {
        key: 'MH',
        label: 'Marshall Islands',
      },
      {
        key: 'MD',
        label: 'Maryland',
      },
      {
        key: 'MA',
        label: 'Massachusetts',
      },
      {
        key: 'MI',
        label: 'Michigan',
      },
      {
        key: 'FM',
        label: 'Micronesia',
      },
      {
        key: 'MN',
        label: 'Minnesota',
      },
      {
        key: 'MS',
        label: 'Mississippi',
      },
      {
        key: 'MO',
        label: 'Missouri',
      },
      {
        key: 'MT',
        label: 'Montana',
      },
      {
        key: 'NE',
        label: 'Nebraska',
      },
      {
        key: 'NV',
        label: 'Nevada',
      },
      {
        key: 'NH',
        label: 'New Hampshire',
      },
      {
        key: 'NJ',
        label: 'New Jersey',
      },
      {
        key: 'NM',
        label: 'New Mexico',
      },
      {
        key: 'NY',
        label: 'New York',
      },
      {
        key: 'NC',
        label: 'North Carolina',
      },
      {
        key: 'ND',
        label: 'North Dakota',
      },
      {
        key: 'MP',
        label: 'Northern Mariana Islands',
      },
      {
        key: 'OH',
        label: 'Ohio',
      },
      {
        key: 'OK',
        label: 'Oklahoma',
      },
      {
        key: 'OR',
        label: 'Oregon',
      },
      {
        key: 'PW',
        label: 'Palau',
      },
      {
        key: 'PA',
        label: 'Pennsylvania',
      },
      {
        key: 'PR',
        label: 'Puerto Rico',
      },
      {
        key: 'RI',
        label: 'Rhode Island',
      },
      {
        key: 'SC',
        label: 'South Carolina',
      },
      {
        key: 'SD',
        label: 'South Dakota',
      },
      {
        key: 'TN',
        label: 'Tennessee',
      },
      {
        key: 'TX',
        label: 'Texas',
      },
      {
        key: 'UT',
        label: 'Utah',
      },
      {
        key: 'VT',
        label: 'Vermont',
      },
      {
        key: 'VI',
        label: 'Virgin Islands',
      },
      {
        key: 'VA',
        label: 'Virginia',
      },
      {
        key: 'WA',
        label: 'Washington',
      },
      {
        key: 'WV',
        label: 'West Virginia',
      },
      {
        key: 'WI',
        label: 'Wisconsin',
      },
      {
        key: 'WY',
        label: 'Wyoming',
      },
    ],
  },
  UY: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '11600',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
    state_label: 'Province',
    state_options: [
      {
        key: 'AR',
        label: 'Artigas',
      },
      {
        key: 'CA',
        label: 'Canelones',
      },
      {
        key: 'CL',
        label: 'Cerro Largo',
      },
      {
        key: 'CO',
        label: 'Colonia',
      },
      {
        key: 'DU',
        label: 'Durazno',
      },
      {
        key: 'FS',
        label: 'Flores',
      },
      {
        key: 'FD',
        label: 'Florida',
      },
      {
        key: 'LA',
        label: 'Lavalleja',
      },
      {
        key: 'MA',
        label: 'Maldonado',
      },
      {
        key: 'MO',
        label: 'Montevideo',
      },
      {
        key: 'PA',
        label: 'Paysandú',
      },
      {
        key: 'RV',
        label: 'Rivera',
      },
      {
        key: 'RO',
        label: 'Rocha',
      },
      {
        key: 'RN',
        label: 'Río Negro',
      },
      {
        key: 'SA',
        label: 'Salto',
      },
      {
        key: 'SJ',
        label: 'San José',
      },
      {
        key: 'SO',
        label: 'Soriano',
      },
      {
        key: 'TA',
        label: 'Tacuarembó',
      },
      {
        key: 'TT',
        label: 'Treinta y Tres',
      },
    ],
  },
  UZ: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '700000',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
    state_label: 'Province',
  },
  VA: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '00120',
    postcode_label: 'Postal code',
    postcode_pattern: '00120',
    required: [],
  },
  VC: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'VC0400',
    postcode_label: 'Postal code',
    postcode_pattern: 'VC\\d{4}',
    required: [],
  },
  VE: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '1020',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'State'],
    state_label: 'State',
    state_options: [
      {
        key: 'Z',
        label: 'Amazonas',
      },
      {
        key: 'B',
        label: 'Anzoátegui',
      },
      {
        key: 'C',
        label: 'Apure',
      },
      {
        key: 'D',
        label: 'Aragua',
      },
      {
        key: 'E',
        label: 'Barinas',
      },
      {
        key: 'F',
        label: 'Bolívar',
      },
      {
        key: 'G',
        label: 'Carabobo',
      },
      {
        key: 'H',
        label: 'Cojedes',
      },
      {
        key: 'Y',
        label: 'Delta Amacuro',
      },
      {
        key: 'W',
        label: 'Dependencias Federales',
      },
      {
        key: 'A',
        label: 'Distrito Federal',
      },
      {
        key: 'I',
        label: 'Falcón',
      },
      {
        key: 'J',
        label: 'Guárico',
      },
      {
        key: 'K',
        label: 'Lara',
      },
      {
        key: 'M',
        label: 'Miranda',
      },
      {
        key: 'N',
        label: 'Monagas',
      },
      {
        key: 'L',
        label: 'Mérida',
      },
      {
        key: 'O',
        label: 'Nueva Esparta',
      },
      {
        key: 'P',
        label: 'Portuguesa',
      },
      {
        key: 'R',
        label: 'Sucre',
      },
      {
        key: 'T',
        label: 'Trujillo',
      },
      {
        key: 'S',
        label: 'Táchira',
      },
      {
        key: 'X',
        label: 'Vargas',
      },
      {
        key: 'U',
        label: 'Yaracuy',
      },
      {
        key: 'V',
        label: 'Zulia',
      },
    ],
  },
  VG: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: 'VG1160',
    postcode_label: 'Postal code',
    postcode_pattern: 'VG\\d{4}',
    required: [],
  },
  VI: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '00850-9802',
    postcode_label: 'Zip code',
    postcode_pattern: '(008(?:(?:[0-4]\\d)|(?:5[01])))(?:[ \\-](\\d{4}))?',
    required: ['City', 'State', 'Postcode'],
    state_label: 'State',
  },
  VN: {
    city_label: 'City',
    fields: ['City', 'State', 'Postcode'],
    postcode_hint: '720344',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{6}',
    required: [],
    state_label: 'Province',
    state_options: [
      {
        key: '44',
        label: 'An Giang Province',
      },
      {
        key: '43',
        label: 'Ba Ria-Vung Tau Province',
      },
      {
        key: '54',
        label: 'Bac Giang Province',
      },
      {
        key: '53',
        label: 'Bac Kan Province',
      },
      {
        key: '55',
        label: 'Bac Lieu Province',
      },
      {
        key: '56',
        label: 'Bac Ninh Province',
      },
      {
        key: '50',
        label: 'Ben Tre Province',
      },
      {
        key: '31',
        label: 'Binh Dinh Province',
      },
      {
        key: '57',
        label: 'Binh Duong Province',
      },
      {
        key: '58',
        label: 'Binh Phuoc Province',
      },
      {
        key: '40',
        label: 'Binh Thuan Province',
      },
      {
        key: '59',
        label: 'Ca Mau Province',
      },
      {
        key: 'CT',
        label: 'Can Tho City',
      },
      {
        key: '04',
        label: 'Cao Bang Province',
      },
      {
        key: 'DN',
        label: 'Da Nang City',
      },
      {
        key: '33',
        label: 'Dak Lak Province',
      },
      {
        key: '72',
        label: 'Dak Nong Province',
      },
      {
        key: '71',
        label: 'Dien Bien Province',
      },
      {
        key: '39',
        label: 'Dong Nai Province',
      },
      {
        key: '45',
        label: 'Dong Thap Province',
      },
      {
        key: '30',
        label: 'Gia Lai Province',
      },
      {
        key: '03',
        label: 'Ha Giang Province',
      },
      {
        key: '63',
        label: 'Ha Nam Province',
      },
      {
        key: '23',
        label: 'Ha Tinh Province',
      },
      {
        key: '61',
        label: 'Hai Duong Province',
      },
      {
        key: 'HP',
        label: 'Haiphong City',
      },
      {
        key: 'HN',
        label: 'Hanoi City',
      },
      {
        key: '73',
        label: 'Hau Giang Province',
      },
      {
        key: 'SG',
        label: 'Ho Chi Minh City',
      },
      {
        key: '14',
        label: 'Hoa Binh Province',
      },
      {
        key: '66',
        label: 'Hung Yen Province',
      },
      {
        key: '34',
        label: 'Khanh Hoa Province',
      },
      {
        key: '47',
        label: 'Kien Giang Province',
      },
      {
        key: '28',
        label: 'Kon Tum Province',
      },
      {
        key: '01',
        label: 'Lai Chau Province',
      },
      {
        key: '35',
        label: 'Lam Dong Province',
      },
      {
        key: '09',
        label: 'Lang Song Province',
      },
      {
        key: '02',
        label: 'Lao Cai Province',
      },
      {
        key: '41',
        label: 'Long An Province',
      },
      {
        key: '67',
        label: 'Nam Dinh Province',
      },
      {
        key: '18',
        label: 'Nanh Binh Province',
      },
      {
        key: '22',
        label: 'Nghe An Province',
      },
      {
        key: '36',
        label: 'Ninh Thuan Province',
      },
      {
        key: '68',
        label: 'Phu Tho Province',
      },
      {
        key: '32',
        label: 'Phu Yen Province',
      },
      {
        key: '24',
        label: 'Quang Binh Province',
      },
      {
        key: '27',
        label: 'Quang Nam Province',
      },
      {
        key: '29',
        label: 'Quang Ngai Province',
      },
      {
        key: '13',
        label: 'Quang Ninh Province',
      },
      {
        key: '25',
        label: 'Quang Tri Province',
      },
      {
        key: '52',
        label: 'Soc Trang Province',
      },
      {
        key: '05',
        label: 'Son La Province',
      },
      {
        key: '37',
        label: 'Tay Ninh Province',
      },
      {
        key: '20',
        label: 'Thai Binh Province',
      },
      {
        key: '69',
        label: 'Thai Nguyen Province',
      },
      {
        key: '21',
        label: 'Thanh Hoa Province',
      },
      {
        key: '26',
        label: 'Thua Thien-Hue Province',
      },
      {
        key: '46',
        label: 'Tien Giang Province',
      },
      {
        key: '51',
        label: 'Tra Vinh Province',
      },
      {
        key: '07',
        label: 'Tuyen Quang Province',
      },
      {
        key: '49',
        label: 'Vinh Long Province',
      },
      {
        key: '70',
        label: 'Vinh Phuc Province',
      },
      {
        key: '06',
        label: 'Yen Bai Province',
      },
    ],
  },
  VU: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  WF: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '98600',
    postcode_label: 'Postal code',
    postcode_pattern: '986\\d{2}',
    required: ['City', 'Postcode'],
  },
  WS: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  YE: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
  YT: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '97600',
    postcode_label: 'Postal code',
    postcode_pattern: '976\\d{2}',
    required: ['City', 'Postcode'],
  },
  ZA: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '1451',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{4}',
    required: ['City', 'Postcode'],
  },
  ZM: {
    city_label: 'City',
    fields: ['City', 'Postcode'],
    postcode_hint: '50101',
    postcode_label: 'Postal code',
    postcode_pattern: '\\d{5}',
    required: [],
  },
  ZW: {
    city_label: 'City',
    fields: ['City'],
    required: [],
  },
};
